webpackJsonp([19843951674672],{

/***/ 955:
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-ease/ v1.0.5 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function linear(t) {
	  return +t;
	}
	
	function quadIn(t) {
	  return t * t;
	}
	
	function quadOut(t) {
	  return t * (2 - t);
	}
	
	function quadInOut(t) {
	  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
	}
	
	function cubicIn(t) {
	  return t * t * t;
	}
	
	function cubicOut(t) {
	  return --t * t * t + 1;
	}
	
	function cubicInOut(t) {
	  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
	}
	
	var exponent = 3;
	
	var polyIn = (function custom(e) {
	  e = +e;
	
	  function polyIn(t) {
	    return Math.pow(t, e);
	  }
	
	  polyIn.exponent = custom;
	
	  return polyIn;
	})(exponent);
	
	var polyOut = (function custom(e) {
	  e = +e;
	
	  function polyOut(t) {
	    return 1 - Math.pow(1 - t, e);
	  }
	
	  polyOut.exponent = custom;
	
	  return polyOut;
	})(exponent);
	
	var polyInOut = (function custom(e) {
	  e = +e;
	
	  function polyInOut(t) {
	    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
	  }
	
	  polyInOut.exponent = custom;
	
	  return polyInOut;
	})(exponent);
	
	var pi = Math.PI,
	    halfPi = pi / 2;
	
	function sinIn(t) {
	  return 1 - Math.cos(t * halfPi);
	}
	
	function sinOut(t) {
	  return Math.sin(t * halfPi);
	}
	
	function sinInOut(t) {
	  return (1 - Math.cos(pi * t)) / 2;
	}
	
	function expIn(t) {
	  return Math.pow(2, 10 * t - 10);
	}
	
	function expOut(t) {
	  return 1 - Math.pow(2, -10 * t);
	}
	
	function expInOut(t) {
	  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
	}
	
	function circleIn(t) {
	  return 1 - Math.sqrt(1 - t * t);
	}
	
	function circleOut(t) {
	  return Math.sqrt(1 - --t * t);
	}
	
	function circleInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
	}
	
	var b1 = 4 / 11,
	    b2 = 6 / 11,
	    b3 = 8 / 11,
	    b4 = 3 / 4,
	    b5 = 9 / 11,
	    b6 = 10 / 11,
	    b7 = 15 / 16,
	    b8 = 21 / 22,
	    b9 = 63 / 64,
	    b0 = 1 / b1 / b1;
	
	function bounceIn(t) {
	  return 1 - bounceOut(1 - t);
	}
	
	function bounceOut(t) {
	  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
	}
	
	function bounceInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
	}
	
	var overshoot = 1.70158;
	
	var backIn = (function custom(s) {
	  s = +s;
	
	  function backIn(t) {
	    return t * t * ((s + 1) * t - s);
	  }
	
	  backIn.overshoot = custom;
	
	  return backIn;
	})(overshoot);
	
	var backOut = (function custom(s) {
	  s = +s;
	
	  function backOut(t) {
	    return --t * t * ((s + 1) * t + s) + 1;
	  }
	
	  backOut.overshoot = custom;
	
	  return backOut;
	})(overshoot);
	
	var backInOut = (function custom(s) {
	  s = +s;
	
	  function backInOut(t) {
	    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
	  }
	
	  backInOut.overshoot = custom;
	
	  return backInOut;
	})(overshoot);
	
	var tau = 2 * Math.PI,
	    amplitude = 1,
	    period = 0.3;
	
	var elasticIn = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticIn(t) {
	    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
	  }
	
	  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
	  elasticIn.period = function(p) { return custom(a, p); };
	
	  return elasticIn;
	})(amplitude, period);
	
	var elasticOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticOut(t) {
	    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
	  }
	
	  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticOut.period = function(p) { return custom(a, p); };
	
	  return elasticOut;
	})(amplitude, period);
	
	var elasticInOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticInOut(t) {
	    return ((t = t * 2 - 1) < 0
	        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
	        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
	  }
	
	  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticInOut.period = function(p) { return custom(a, p); };
	
	  return elasticInOut;
	})(amplitude, period);
	
	exports.easeLinear = linear;
	exports.easeQuad = quadInOut;
	exports.easeQuadIn = quadIn;
	exports.easeQuadOut = quadOut;
	exports.easeQuadInOut = quadInOut;
	exports.easeCubic = cubicInOut;
	exports.easeCubicIn = cubicIn;
	exports.easeCubicOut = cubicOut;
	exports.easeCubicInOut = cubicInOut;
	exports.easePoly = polyInOut;
	exports.easePolyIn = polyIn;
	exports.easePolyOut = polyOut;
	exports.easePolyInOut = polyInOut;
	exports.easeSin = sinInOut;
	exports.easeSinIn = sinIn;
	exports.easeSinOut = sinOut;
	exports.easeSinInOut = sinInOut;
	exports.easeExp = expInOut;
	exports.easeExpIn = expIn;
	exports.easeExpOut = expOut;
	exports.easeExpInOut = expInOut;
	exports.easeCircle = circleInOut;
	exports.easeCircleIn = circleIn;
	exports.easeCircleOut = circleOut;
	exports.easeCircleInOut = circleInOut;
	exports.easeBounce = bounceOut;
	exports.easeBounceIn = bounceIn;
	exports.easeBounceOut = bounceOut;
	exports.easeBounceInOut = bounceInOut;
	exports.easeBack = backInOut;
	exports.easeBackIn = backIn;
	exports.easeBackOut = backOut;
	exports.easeBackInOut = backInOut;
	exports.easeElastic = elasticOut;
	exports.easeElasticIn = elasticIn;
	exports.easeElasticOut = elasticOut;
	exports.easeElasticInOut = elasticInOut;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ 792:
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-timer/ v1.0.9 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var frame = 0, // is an animation frame pending?
	    timeout = 0, // is a timeout pending?
	    interval = 0, // are any timers active?
	    pokeDelay = 1000, // how frequently we check for clock skew
	    taskHead,
	    taskTail,
	    clockLast = 0,
	    clockNow = 0,
	    clockSkew = 0,
	    clock = typeof performance === "object" && performance.now ? performance : Date,
	    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };
	
	function now() {
	  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
	}
	
	function clearNow() {
	  clockNow = 0;
	}
	
	function Timer() {
	  this._call =
	  this._time =
	  this._next = null;
	}
	
	Timer.prototype = timer.prototype = {
	  constructor: Timer,
	  restart: function(callback, delay, time) {
	    if (typeof callback !== "function") throw new TypeError("callback is not a function");
	    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
	    if (!this._next && taskTail !== this) {
	      if (taskTail) taskTail._next = this;
	      else taskHead = this;
	      taskTail = this;
	    }
	    this._call = callback;
	    this._time = time;
	    sleep();
	  },
	  stop: function() {
	    if (this._call) {
	      this._call = null;
	      this._time = Infinity;
	      sleep();
	    }
	  }
	};
	
	function timer(callback, delay, time) {
	  var t = new Timer;
	  t.restart(callback, delay, time);
	  return t;
	}
	
	function timerFlush() {
	  now(); // Get the current time, if not already set.
	  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
	  var t = taskHead, e;
	  while (t) {
	    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
	    t = t._next;
	  }
	  --frame;
	}
	
	function wake() {
	  clockNow = (clockLast = clock.now()) + clockSkew;
	  frame = timeout = 0;
	  try {
	    timerFlush();
	  } finally {
	    frame = 0;
	    nap();
	    clockNow = 0;
	  }
	}
	
	function poke() {
	  var now = clock.now(), delay = now - clockLast;
	  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
	}
	
	function nap() {
	  var t0, t1 = taskHead, t2, time = Infinity;
	  while (t1) {
	    if (t1._call) {
	      if (time > t1._time) time = t1._time;
	      t0 = t1, t1 = t1._next;
	    } else {
	      t2 = t1._next, t1._next = null;
	      t1 = t0 ? t0._next = t2 : taskHead = t2;
	    }
	  }
	  taskTail = t0;
	  sleep(time);
	}
	
	function sleep(time) {
	  if (frame) return; // Soonest alarm already set, or will be.
	  if (timeout) timeout = clearTimeout(timeout);
	  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
	  if (delay > 24) {
	    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
	    if (interval) interval = clearInterval(interval);
	  } else {
	    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
	    frame = 1, setFrame(wake);
	  }
	}
	
	function timeout$1(callback, delay, time) {
	  var t = new Timer;
	  delay = delay == null ? 0 : +delay;
	  t.restart(function(elapsed) {
	    t.stop();
	    callback(elapsed + delay);
	  }, delay, time);
	  return t;
	}
	
	function interval$1(callback, delay, time) {
	  var t = new Timer, total = delay;
	  if (delay == null) return t.restart(callback, delay, time), t;
	  delay = +delay, time = time == null ? now() : +time;
	  t.restart(function tick(elapsed) {
	    elapsed += total;
	    t.restart(tick, total += delay, time);
	    callback(elapsed);
	  }, delay, time);
	  return t;
	}
	
	exports.now = now;
	exports.timer = timer;
	exports.timerFlush = timerFlush;
	exports.timeout = timeout$1;
	exports.interval = interval$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ 962:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 1010:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _d3Timer = __webpack_require__(792);
	
	var _utils = __webpack_require__(798);
	
	var _Events = _interopRequireDefault(__webpack_require__(1011));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	var BaseNode = function () {
	  function BaseNode(state) {
	    _classCallCheck(this, BaseNode);
	
	    this.state = state || {};
	  }
	
	  _createClass(BaseNode, [{
	    key: "transition",
	    value: function transition(config) {
	      if (Array.isArray(config)) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = config[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var item = _step.value;
	            this.parse(item);
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return != null) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      } else {
	        this.parse(config);
	      }
	    }
	  }, {
	    key: "isTransitioning",
	    value: function isTransitioning() {
	      return !!this.transitionData;
	    }
	  }, {
	    key: "stopTransitions",
	    value: function stopTransitions() {
	      var transitions = this.transitionData;
	
	      if (transitions) {
	        Object.keys(transitions).forEach(function (t) {
	          transitions[t].timer.stop();
	        });
	      }
	    }
	  }, {
	    key: "setState",
	    value: function setState(update) {
	      if (typeof update === 'function') {
	        (0, _utils.extend)(this.state, update(this.state));
	      } else {
	        (0, _utils.extend)(this.state, update);
	      }
	    }
	  }, {
	    key: "parse",
	    value: function parse(config) {
	      var _this = this;
	
	      var clone = _objectSpread({}, config);
	
	      var events = new _Events.default(clone);
	
	      if (clone.events) {
	        delete clone.events;
	      }
	
	      var timing = _objectSpread({}, _utils.timingDefaults, clone.timing || {}, {
	        time: (0, _d3Timer.now)()
	      });
	
	      if (clone.timing) {
	        delete clone.timing;
	      }
	
	      Object.keys(clone).forEach(function (stateKey) {
	        var tweens = [];
	        var next = clone[stateKey];
	
	        if ((0, _utils.isNamespace)(next)) {
	          Object.keys(next).forEach(function (attr) {
	            var val = next[attr];
	
	            if (Array.isArray(val)) {
	              if (val.length === 1) {
	                tweens.push(_this.getTween(attr, val[0], stateKey));
	              } else {
	                _this.setState(function (state) {
	                  var _objectSpread2, _ref;
	
	                  return _ref = {}, _ref[stateKey] = _objectSpread({}, state[stateKey], (_objectSpread2 = {}, _objectSpread2[attr] = val[0], _objectSpread2)), _ref;
	                });
	
	                tweens.push(_this.getTween(attr, val[1], stateKey));
	              }
	            } else if (typeof val === 'function') {
	              var getNameSpacedCustomTween = function getNameSpacedCustomTween() {
	                var kapellmeisterNamespacedTween = function kapellmeisterNamespacedTween(t) {
	                  _this.setState(function (state) {
	                    var _objectSpread3, _ref2;
	
	                    return _ref2 = {}, _ref2[stateKey] = _objectSpread({}, state[stateKey], (_objectSpread3 = {}, _objectSpread3[attr] = val(t), _objectSpread3)), _ref2;
	                  });
	                };
	
	                return kapellmeisterNamespacedTween;
	              };
	
	              tweens.push(getNameSpacedCustomTween);
	            } else {
	              _this.setState(function (state) {
	                var _objectSpread4, _ref3;
	
	                return _ref3 = {}, _ref3[stateKey] = _objectSpread({}, state[stateKey], (_objectSpread4 = {}, _objectSpread4[attr] = val, _objectSpread4)), _ref3;
	              });
	
	              tweens.push(_this.getTween(attr, val, stateKey));
	            }
	          });
	        } else {
	          if (Array.isArray(next)) {
	            if (next.length === 1) {
	              tweens.push(_this.getTween(stateKey, next[0], null));
	            } else {
	              var _this$setState;
	
	              _this.setState((_this$setState = {}, _this$setState[stateKey] = next[0], _this$setState));
	
	              tweens.push(_this.getTween(stateKey, next[1], null));
	            }
	          } else if (typeof next === 'function') {
	            var getCustomTween = function getCustomTween() {
	              var kapellmeisterTween = function kapellmeisterTween(t) {
	                var _this$setState2;
	
	                _this.setState((_this$setState2 = {}, _this$setState2[stateKey] = next(t), _this$setState2));
	              };
	
	              return kapellmeisterTween;
	            };
	
	            tweens.push(getCustomTween);
	          } else {
	            var _this$setState3;
	
	            _this.setState((_this$setState3 = {}, _this$setState3[stateKey] = next, _this$setState3));
	
	            tweens.push(_this.getTween(stateKey, next, null));
	          }
	        }
	
	        _this.update({
	          stateKey: stateKey,
	          timing: timing,
	          tweens: tweens,
	          events: events,
	          status: 0
	        });
	      });
	    }
	  }, {
	    key: "getTween",
	    value: function getTween(attr, endValue, nameSpace) {
	      var _this2 = this;
	
	      return function () {
	        var begValue = nameSpace ? _this2.state[nameSpace][attr] : _this2.state[attr];
	
	        if (begValue === endValue) {
	          return null;
	        }
	
	        var i = _this2.getInterpolator(begValue, endValue, attr, nameSpace);
	
	        var stateTween;
	
	        if (nameSpace === null) {
	          stateTween = function stateTween(t) {
	            var _this2$setState;
	
	            _this2.setState((_this2$setState = {}, _this2$setState[attr] = i(t), _this2$setState));
	          };
	        } else {
	          stateTween = function stateTween(t) {
	            _this2.setState(function (state) {
	              var _objectSpread5, _ref4;
	
	              return _ref4 = {}, _ref4[nameSpace] = _objectSpread({}, state[nameSpace], (_objectSpread5 = {}, _objectSpread5[attr] = i(t), _objectSpread5)), _ref4;
	            });
	          };
	        }
	
	        return stateTween;
	      };
	    }
	  }, {
	    key: "update",
	    value: function update(transition) {
	      if (!this.transitionData) {
	        this.transitionData = {};
	      }
	
	      this.init((0, _utils.getTransitionId)(), transition);
	    }
	  }, {
	    key: "init",
	    value: function init(id, transition) {
	      var _this3 = this;
	
	      var n = transition.tweens.length;
	      var tweens = new Array(n);
	
	      var queue = function queue(elapsed) {
	        transition.status = 1;
	        transition.timer.restart(start, transition.timing.delay, transition.timing.time);
	
	        if (transition.timing.delay <= elapsed) {
	          start(elapsed - transition.timing.delay);
	        }
	      };
	
	      this.transitionData[id] = transition;
	      transition.timer = (0, _d3Timer.timer)(queue, 0, transition.timing.time);
	
	      var start = function start(elapsed) {
	        if (transition.status !== 1) return stop();
	
	        for (var tid in _this3.transitionData) {
	          var t = _this3.transitionData[tid];
	
	          if (t.stateKey !== transition.stateKey) {
	            continue;
	          }
	
	          if (t.status === 3) {
	            return (0, _d3Timer.timeout)(start);
	          }
	
	          if (t.status === 4) {
	            t.status = 6;
	            t.timer.stop();
	
	            if (t.events.interrupt) {
	              t.events.interrupt.call(_this3);
	            }
	
	            delete _this3.transitionData[tid];
	          } else if (+tid < id) {
	            t.status = 6;
	            t.timer.stop();
	            delete _this3.transitionData[tid];
	          }
	        }
	
	        (0, _d3Timer.timeout)(function () {
	          if (transition.status === 3) {
	            transition.status = 4;
	            transition.timer.restart(tick, transition.timing.delay, transition.timing.time);
	            tick(elapsed);
	          }
	        });
	        transition.status = 2;
	
	        if (transition.events.start) {
	          transition.events.start.call(_this3);
	        }
	
	        if (transition.status !== 2) {
	          return;
	        }
	
	        transition.status = 3;
	        var j = -1;
	
	        for (var i = 0; i < n; ++i) {
	          var res = transition.tweens[i]();
	
	          if (res) {
	            tweens[++j] = res;
	          }
	        }
	
	        tweens.length = j + 1;
	      };
	
	      var tick = function tick(elapsed) {
	        var t = 1;
	
	        if (elapsed < transition.timing.duration) {
	          t = transition.timing.ease(elapsed / transition.timing.duration);
	        } else {
	          transition.timer.restart(stop);
	          transition.status = 5;
	        }
	
	        var i = -1;
	
	        while (++i < tweens.length) {
	          tweens[i](t);
	        }
	
	        if (transition.status === 5) {
	          if (transition.events.end) {
	            transition.events.end.call(_this3);
	          }
	
	          stop();
	        }
	      };
	
	      var stop = function stop() {
	        transition.status = 6;
	        transition.timer.stop();
	        delete _this3.transitionData[id];
	
	        for (var _ in _this3.transitionData) {
	          return;
	        }
	
	        delete _this3.transitionData;
	      };
	    }
	  }]);
	
	  return BaseNode;
	}();
	
	var _default = BaseNode;
	exports.default = _default;

/***/ }),

/***/ 1011:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Events = void 0;
	
	var _utils = __webpack_require__(798);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Events = function Events(config) {
	  var _this = this;
	
	  _classCallCheck(this, Events);
	
	  this.start = null;
	  this.interrupt = null;
	  this.end = null;
	
	  if (config.events) {
	    Object.keys(config.events).forEach(function (d) {
	      if (typeof config.events[d] !== 'function') {
	        throw new Error('Event handlers must be a function');
	      } else {
	        _this[d] = (0, _utils.once)(config.events[d]);
	      }
	    });
	  }
	};
	
	exports.Events = Events;
	var _default = Events;
	exports.default = _default;

/***/ }),

/***/ 1012:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "BaseNode", {
	  enumerable: true,
	  get: function get() {
	    return _BaseNode.default;
	  }
	});
	Object.defineProperty(exports, "now", {
	  enumerable: true,
	  get: function get() {
	    return _d3Timer.now;
	  }
	});
	Object.defineProperty(exports, "timer", {
	  enumerable: true,
	  get: function get() {
	    return _d3Timer.timer;
	  }
	});
	Object.defineProperty(exports, "interval", {
	  enumerable: true,
	  get: function get() {
	    return _d3Timer.interval;
	  }
	});
	Object.defineProperty(exports, "timeout", {
	  enumerable: true,
	  get: function get() {
	    return _d3Timer.timeout;
	  }
	});
	
	var _BaseNode = _interopRequireDefault(__webpack_require__(1010));
	
	var _d3Timer = __webpack_require__(792);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 798:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTransitionId = getTransitionId;
	exports.extend = extend;
	exports.once = once;
	exports.isNamespace = isNamespace;
	exports.timingDefaults = void 0;
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	var transitionId = 0;
	
	function getTransitionId() {
	  return ++transitionId;
	}
	
	function extend(obj, props) {
	  for (var i in props) {
	    obj[i] = props[i];
	  }
	}
	
	function once(func) {
	  var called = false;
	  return function transitionEvent() {
	    if (!called) {
	      called = true;
	      func.call(this);
	    }
	  };
	}
	
	function isNamespace(prop) {
	  return _typeof(prop) === 'object' && Array.isArray(prop) === false;
	}
	
	var linear = function linear(t) {
	  return +t;
	};
	
	var timingDefaults = {
	  delay: 0,
	  duration: 250,
	  ease: linear
	};
	exports.timingDefaults = timingDefaults;

/***/ }),

/***/ 1022:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(700).default;
	module.exports.default = module.exports;
	module.exports.NextButton = __webpack_require__(700).NextButton;
	module.exports.PreviousButton = __webpack_require__(700).PreviousButton;
	module.exports.PagingDots = __webpack_require__(700).PagingDots;


/***/ }),

/***/ 1023:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _scrollTransition = _interopRequireDefault(__webpack_require__(1028));
	
	var _fadeTransition = _interopRequireDefault(__webpack_require__(1027));
	
	var _dScrollTransition = _interopRequireDefault(__webpack_require__(1026));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = {
	  fade: _fadeTransition["default"],
	  scroll: _scrollTransition["default"],
	  scroll3d: _dScrollTransition["default"]
	};
	exports["default"] = _default;

/***/ }),

/***/ 1024:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.defaultRenderAnnounceSlideMessage = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var AnnounceSlide = function AnnounceSlide(_ref) {
	  var message = _ref.message;
	  var styles = {
	    position: 'absolute',
	    left: '-10000px',
	    top: 'auto',
	    width: '1px',
	    height: '1px',
	    overflow: 'hidden'
	  };
	  return _react["default"].createElement("div", {
	    "aria-live": "polite",
	    "aria-atomic": "true",
	    style: styles,
	    tabIndex: -1
	  }, message);
	};
	
	var defaultRenderAnnounceSlideMessage = function defaultRenderAnnounceSlideMessage(_ref2) {
	  var currentSlide = _ref2.currentSlide,
	      slideCount = _ref2.slideCount;
	  return "Slide ".concat(currentSlide + 1, " of ").concat(slideCount);
	};
	
	exports.defaultRenderAnnounceSlideMessage = defaultRenderAnnounceSlideMessage;
	var _default = AnnounceSlide;
	exports["default"] = _default;

/***/ }),

/***/ 1025:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PagingDots = exports.NextButton = exports.PreviousButton = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var defaultButtonStyles = function defaultButtonStyles(disabled) {
	  return {
	    border: 0,
	    background: 'rgba(0,0,0,0.4)',
	    color: 'white',
	    padding: 10,
	    opacity: disabled ? 0.3 : 1,
	    cursor: disabled ? 'not-allowed' : 'pointer'
	  };
	};
	
	var PreviousButton =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(PreviousButton, _React$Component);
	
	  function PreviousButton() {
	    var _this;
	
	    _classCallCheck(this, PreviousButton);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(PreviousButton).apply(this, arguments));
	    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
	    return _this;
	  }
	
	  _createClass(PreviousButton, [{
	    key: "handleClick",
	    value: function handleClick(event) {
	      event.preventDefault();
	      this.props.previousSlide();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var disabled = this.props.currentSlide === 0 && !this.props.wrapAround || this.props.slideCount === 0;
	      return _react["default"].createElement("button", {
	        style: defaultButtonStyles(disabled),
	        disabled: disabled,
	        onClick: this.handleClick,
	        "aria-label": "previous",
	        type: "button"
	      }, "PREV");
	    }
	  }]);
	
	  return PreviousButton;
	}(_react["default"].Component);
	
	exports.PreviousButton = PreviousButton;
	
	var NextButton =
	/*#__PURE__*/
	function (_React$Component2) {
	  _inherits(NextButton, _React$Component2);
	
	  function NextButton() {
	    var _this2;
	
	    _classCallCheck(this, NextButton);
	
	    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(NextButton).apply(this, arguments));
	    _this2.handleClick = _this2.handleClick.bind(_assertThisInitialized(_this2));
	    _this2.nextButtonDisable = _this2.nextButtonDisabled.bind(_assertThisInitialized(_this2));
	    return _this2;
	  }
	
	  _createClass(NextButton, [{
	    key: "handleClick",
	    value: function handleClick(event) {
	      event.preventDefault();
	      this.props.nextSlide();
	    }
	  }, {
	    key: "nextButtonDisabled",
	    value: function nextButtonDisabled(params) {
	      var wrapAround = params.wrapAround,
	          slidesToShow = params.slidesToShow,
	          currentSlide = params.currentSlide,
	          cellAlign = params.cellAlign,
	          slideCount = params.slideCount;
	      var buttonDisabled = false;
	
	      if (!wrapAround) {
	        var lastSlideIndex = slideCount - 1;
	        var slidesShowing = slidesToShow;
	        var lastSlideOffset = 0;
	
	        switch (cellAlign) {
	          case 'center':
	            slidesShowing = (slidesToShow - 1) * 0.5;
	            lastSlideOffset = Math.floor(slidesToShow * 0.5) - 1;
	            break;
	
	          case 'right':
	            slidesShowing = 1;
	            break;
	        }
	
	        if (slidesToShow > 1) {
	          buttonDisabled = currentSlide + slidesShowing > lastSlideIndex + lastSlideOffset;
	        } else {
	          buttonDisabled = currentSlide + 1 > lastSlideIndex;
	        }
	      }
	
	      return buttonDisabled;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          wrapAround = _this$props.wrapAround,
	          slidesToShow = _this$props.slidesToShow,
	          currentSlide = _this$props.currentSlide,
	          cellAlign = _this$props.cellAlign,
	          slideCount = _this$props.slideCount;
	      var disabled = this.nextButtonDisabled({
	        wrapAround: wrapAround,
	        slidesToShow: slidesToShow,
	        currentSlide: currentSlide,
	        cellAlign: cellAlign,
	        slideCount: slideCount
	      });
	      return _react["default"].createElement("button", {
	        style: defaultButtonStyles(disabled),
	        disabled: disabled,
	        onClick: this.handleClick,
	        "aria-label": "next",
	        type: "button"
	      }, "NEXT");
	    }
	  }]);
	
	  return NextButton;
	}(_react["default"].Component);
	
	exports.NextButton = NextButton;
	
	var PagingDots =
	/*#__PURE__*/
	function (_React$Component3) {
	  _inherits(PagingDots, _React$Component3);
	
	  function PagingDots() {
	    _classCallCheck(this, PagingDots);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(PagingDots).apply(this, arguments));
	  }
	
	  _createClass(PagingDots, [{
	    key: "getDotIndexes",
	    value: function getDotIndexes(slideCount, slidesToScroll, slidesToShow, cellAlign) {
	      var dotIndexes = [];
	      var lastDotIndex = slideCount - slidesToShow;
	
	      switch (cellAlign) {
	        case 'center':
	        case 'right':
	          lastDotIndex += slidesToShow - 1;
	          break;
	      }
	
	      if (lastDotIndex < 0) {
	        return [0];
	      }
	
	      for (var i = 0; i < lastDotIndex; i += slidesToScroll) {
	        dotIndexes.push(i);
	      }
	
	      dotIndexes.push(lastDotIndex);
	      return dotIndexes;
	    }
	  }, {
	    key: "getListStyles",
	    value: function getListStyles() {
	      return {
	        position: 'relative',
	        margin: 0,
	        top: -10,
	        padding: 0
	      };
	    }
	  }, {
	    key: "getListItemStyles",
	    value: function getListItemStyles() {
	      return {
	        listStyleType: 'none',
	        display: 'inline-block'
	      };
	    }
	  }, {
	    key: "getButtonStyles",
	    value: function getButtonStyles(active) {
	      return {
	        cursor: 'pointer',
	        opacity: active ? 1 : 0.5,
	        background: 'transparent',
	        border: 'none'
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var indexes = this.getDotIndexes(this.props.slideCount, this.props.slidesToScroll, this.props.slidesToShow, this.props.cellAlign);
	      return _react["default"].createElement("ul", {
	        style: this.getListStyles()
	      }, indexes.map(function (index) {
	        return _react["default"].createElement("li", {
	          style: _this3.getListItemStyles(),
	          key: index,
	          className: _this3.props.currentSlide === index ? 'paging-item active' : 'paging-item'
	        }, _react["default"].createElement("button", {
	          type: "button",
	          style: _this3.getButtonStyles(_this3.props.currentSlide === index),
	          onClick: _this3.props.goToSlide.bind(null, index),
	          "aria-label": "slide ".concat(index + 1, " bullet")
	        }, _react["default"].createElement("span", {
	          className: "paging-dot",
	          style: {
	            display: 'inline-block',
	            borderRadius: '50%',
	            width: '6px',
	            height: '6px',
	            background: 'black'
	          }
	        })));
	      }));
	    }
	  }]);
	
	  return PagingDots;
	}(_react["default"].Component);
	
	exports.PagingDots = PagingDots;

/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "PagingDots", {
	  enumerable: true,
	  get: function get() {
	    return _defaultControls.PagingDots;
	  }
	});
	Object.defineProperty(exports, "PreviousButton", {
	  enumerable: true,
	  get: function get() {
	    return _defaultControls.PreviousButton;
	  }
	});
	Object.defineProperty(exports, "NextButton", {
	  enumerable: true,
	  get: function get() {
	    return _defaultControls.NextButton;
	  }
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _exenv = _interopRequireDefault(__webpack_require__(962));
	
	var _Animate = _interopRequireDefault(__webpack_require__(1443));
	
	var easing = _interopRequireWildcard(__webpack_require__(955));
	
	var _defaultControls = __webpack_require__(1025);
	
	var _allTransitions = _interopRequireDefault(__webpack_require__(1023));
	
	var _announceSlide = _interopRequireWildcard(__webpack_require__(1024));
	
	var _utilities = __webpack_require__(1031);
	
	var _styleUtilities = __webpack_require__(1030);
	
	var _bootstrappingUtilities = __webpack_require__(1029);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Carousel =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Carousel, _React$Component);
	
	  function Carousel() {
	    var _this;
	
	    _classCallCheck(this, Carousel);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Carousel).apply(this, arguments));
	    _this.displayName = 'Carousel';
	    _this.clickDisabled = false;
	    _this.isTransitioning = false;
	    _this.timers = [];
	    _this.touchObject = {};
	    _this.controlsMap = [{
	      funcName: 'renderTopLeftControls',
	      key: 'TopLeft'
	    }, {
	      funcName: 'renderTopCenterControls',
	      key: 'TopCenter'
	    }, {
	      funcName: 'renderTopRightControls',
	      key: 'TopRight'
	    }, {
	      funcName: 'renderCenterLeftControls',
	      key: 'CenterLeft'
	    }, {
	      funcName: 'renderCenterCenterControls',
	      key: 'CenterCenter'
	    }, {
	      funcName: 'renderCenterRightControls',
	      key: 'CenterRight'
	    }, {
	      funcName: 'renderBottomLeftControls',
	      key: 'BottomLeft'
	    }, {
	      funcName: 'renderBottomCenterControls',
	      key: 'BottomCenter'
	    }, {
	      funcName: 'renderBottomRightControls',
	      key: 'BottomRight'
	    }];
	    _this.childNodesMutationObs = null;
	    _this.state = _objectSpread({
	      currentSlide: _this.props.slideIndex,
	      dragging: false,
	      easing: _this.props.disableAnimation ? '' : easing.easeCircleOut,
	      hasInteraction: false,
	      // to remove animation from the initial slide on the page load when non-default slideIndex is used
	      isWrappingAround: false,
	      left: 0,
	      resetWrapAroundPosition: false,
	      slideCount: (0, _bootstrappingUtilities.getValidChildren)(_this.props.children).length,
	      top: 0,
	      wrapToIndex: null,
	      readyStateChanged: 0
	    }, (0, _utilities.calcSomeInitialState)(_this.props));
	    _this.autoplayIterator = _this.autoplayIterator.bind(_assertThisInitialized(_this));
	    _this.calcSlideHeightAndWidth = _this.calcSlideHeightAndWidth.bind(_assertThisInitialized(_this));
	    _this.getChildNodes = _this.getChildNodes.bind(_assertThisInitialized(_this));
	    _this.getMouseEvents = _this.getMouseEvents.bind(_assertThisInitialized(_this));
	    _this.getOffsetDeltas = _this.getOffsetDeltas.bind(_assertThisInitialized(_this));
	    _this.getTargetLeft = _this.getTargetLeft.bind(_assertThisInitialized(_this));
	    _this.getTouchEvents = _this.getTouchEvents.bind(_assertThisInitialized(_this));
	    _this.goToSlide = _this.goToSlide.bind(_assertThisInitialized(_this));
	    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
	    _this.handleKeyPress = _this.handleKeyPress.bind(_assertThisInitialized(_this));
	    _this.handleMouseOut = _this.handleMouseOut.bind(_assertThisInitialized(_this));
	    _this.handleMouseOver = _this.handleMouseOver.bind(_assertThisInitialized(_this));
	    _this.handleSwipe = _this.handleSwipe.bind(_assertThisInitialized(_this));
	    _this.nextSlide = _this.nextSlide.bind(_assertThisInitialized(_this));
	    _this.onReadyStateChange = _this.onReadyStateChange.bind(_assertThisInitialized(_this));
	    _this.onResize = _this.onResize.bind(_assertThisInitialized(_this));
	    _this.onVisibilityChange = _this.onVisibilityChange.bind(_assertThisInitialized(_this));
	    _this.previousSlide = _this.previousSlide.bind(_assertThisInitialized(_this));
	    _this.renderControls = _this.renderControls.bind(_assertThisInitialized(_this));
	    _this.resetAutoplay = _this.resetAutoplay.bind(_assertThisInitialized(_this));
	    _this.setDimensions = _this.setDimensions.bind(_assertThisInitialized(_this));
	    _this.setLeft = _this.setLeft.bind(_assertThisInitialized(_this));
	    _this.setSlideHeightAndWidth = _this.setSlideHeightAndWidth.bind(_assertThisInitialized(_this));
	    _this.startAutoplay = _this.startAutoplay.bind(_assertThisInitialized(_this));
	    _this.stopAutoplay = _this.stopAutoplay.bind(_assertThisInitialized(_this));
	    _this.establishChildNodesMutationObserver = _this.establishChildNodesMutationObserver.bind(_assertThisInitialized(_this));
	    return _this;
	  }
	
	  _createClass(Carousel, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // see https://github.com/facebook/react/issues/3417#issuecomment-121649937
	      this.mounted = true;
	      this.setLeft();
	      this.setDimensions();
	      this.bindEvents();
	      this.establishChildNodesMutationObserver();
	
	      if (this.props.autoplay) {
	        this.startAutoplay();
	      }
	    } // @TODO Remove deprecated componentWillReceiveProps with getDerivedStateFromProps
	    // eslint-disable-next-line react/no-deprecated
	
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var slideCount = (0, _bootstrappingUtilities.getValidChildren)(nextProps.children).length;
	      var slideCountChanged = slideCount !== this.state.slideCount;
	      this.setState(function (prevState) {
	        return {
	          slideCount: slideCount,
	          currentSlide: slideCountChanged ? nextProps.slideIndex : prevState.currentSlide
	        };
	      });
	
	      if (slideCount <= this.state.currentSlide) {
	        this.goToSlide(Math.max(slideCount - 1, 0), nextProps);
	      }
	
	      var updateDimensions = slideCountChanged || (0, _utilities.shouldUpdate)(this.props, nextProps, ['cellSpacing', 'vertical', 'slideWidth', 'slideHeight', 'heightMode', 'slidesToScroll', 'slidesToShow', 'transitionMode', 'cellAlign']);
	
	      if (updateDimensions) {
	        this.setDimensions(nextProps);
	      }
	
	      if (this.props.slideIndex !== nextProps.slideIndex && nextProps.slideIndex !== this.state.currentSlide && !this.state.isWrappingAround) {
	        this.goToSlide(nextProps.slideIndex, this.props);
	      }
	
	      if (this.props.autoplay !== nextProps.autoplay) {
	        if (nextProps.autoplay) {
	          this.startAutoplay();
	        } else {
	          this.stopAutoplay();
	        }
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      var slideChanged = prevState.currentSlide !== this.state.currentSlide;
	      var heightModeChanged = prevProps.heightMode !== this.props.heightMode;
	      var axisChanged = prevProps.vertical !== this.props.vertical;
	
	      if (axisChanged) {
	        this.onResize();
	      } else if (slideChanged || heightModeChanged) {
	        var image = this.getCurrentChildNodeImg();
	
	        if (image) {
	          image.addEventListener('load', this.setSlideHeightAndWidth);
	          image.removeEventListener('load', this.setSlideHeightAndWidth);
	        } else {
	          this.setSlideHeightAndWidth();
	        }
	      }
	
	      var _this$calcSlideHeight = this.calcSlideHeightAndWidth(),
	          slideHeight = _this$calcSlideHeight.slideHeight;
	
	      var heightMismatches = slideHeight !== prevState.slideHeight; // When using dynamic content in a slide, it is possible for the slide height to be inaccurate. Here, double check that the height is correct once the component has mounted and the `readyStateChange` event has fired.
	      // See #521 and https://github.com/FormidableLabs/nuka-carousel/blob/fea63242a8b2fb69c65689efe615d0feb9b2d1ff/README.md#resizing-height-issue
	
	      if (this.mounted && prevState.readyStateChanged > 0 && heightMismatches) {
	        this.setDimensions();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.unbindEvents();
	      this.disconnectChildNodesMutationObserver();
	      this.stopAutoplay(); // see https://github.com/facebook/react/issues/3417#issuecomment-121649937
	
	      this.mounted = false;
	
	      for (var i = 0; i < this.timers.length; i++) {
	        clearTimeout(this.timers[i]);
	      }
	    }
	  }, {
	    key: "establishChildNodesMutationObserver",
	    value: function establishChildNodesMutationObserver() {
	      var _this2 = this;
	
	      var childNodes = this.getChildNodes();
	
	      if (childNodes.length && 'MutationObserver' in window) {
	        this.childNodesMutationObs = new MutationObserver(function (mutations) {
	          mutations.forEach(function () {
	            _this2.setSlideHeightAndWidth();
	          });
	        });
	
	        var observeChildNodeMutation = function observeChildNodeMutation(node) {
	          _this2.childNodesMutationObs.observe(node, {
	            attributes: true,
	            attributeFilter: ['style'],
	            attributeOldValue: false,
	            characterData: false,
	            characterDataOldValue: false,
	            childList: false,
	            subtree: false
	          });
	        };
	
	        var childNodesArray = Array.from(childNodes);
	
	        for (var _i = 0, _childNodesArray = childNodesArray; _i < _childNodesArray.length; _i++) {
	          var node = _childNodesArray[_i];
	          observeChildNodeMutation(node);
	        }
	      }
	    }
	  }, {
	    key: "disconnectChildNodesMutationObserver",
	    value: function disconnectChildNodesMutationObserver() {
	      if (this.childNodesMutationObs instanceof MutationObserver) {
	        this.childNodesMutationObs.disconnect();
	      }
	    }
	  }, {
	    key: "getTouchEvents",
	    value: function getTouchEvents() {
	      var _this3 = this;
	
	      if (this.props.swiping === false) {
	        return {
	          onTouchStart: this.handleMouseOver,
	          onTouchEnd: this.handleMouseOut
	        };
	      }
	
	      return {
	        onTouchStart: function onTouchStart(e) {
	          _this3.touchObject = {
	            startX: e.touches[0].pageX,
	            startY: e.touches[0].pageY
	          };
	
	          _this3.handleMouseOver();
	
	          _this3.setState({
	            dragging: true
	          });
	        },
	        onTouchMove: function onTouchMove(e) {
	          var direction = (0, _utilities.swipeDirection)(_this3.touchObject.startX, e.touches[0].pageX, _this3.touchObject.startY, e.touches[0].pageY, _this3.props.vertical);
	
	          if (direction !== 0) {
	            e.preventDefault();
	          }
	
	          var length = _this3.props.vertical ? Math.round(Math.sqrt(Math.pow(e.touches[0].pageY - _this3.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.touches[0].pageX - _this3.touchObject.startX, 2)));
	
	          if (length >= 10) {
	            if (_this3.clickDisabled === false) _this3.props.onDragStart(e);
	            _this3.clickDisabled = true;
	          }
	
	          _this3.touchObject = {
	            startX: _this3.touchObject.startX,
	            startY: _this3.touchObject.startY,
	            endX: e.touches[0].pageX,
	            endY: e.touches[0].pageY,
	            length: length,
	            direction: direction
	          };
	
	          _this3.setState({
	            left: _this3.props.vertical ? 0 : _this3.getTargetLeft(_this3.touchObject.length * _this3.touchObject.direction),
	            top: _this3.props.vertical ? _this3.getTargetLeft(_this3.touchObject.length * _this3.touchObject.direction) : 0
	          });
	        },
	        onTouchEnd: function onTouchEnd(e) {
	          _this3.handleSwipe(e);
	
	          _this3.handleMouseOut();
	        },
	        onTouchCancel: function onTouchCancel(e) {
	          _this3.handleSwipe(e);
	        }
	      };
	    }
	  }, {
	    key: "getMouseEvents",
	    value: function getMouseEvents() {
	      var _this4 = this;
	
	      if (this.props.dragging === false) {
	        return {
	          onMouseOver: this.handleMouseOver,
	          onMouseOut: this.handleMouseOut
	        };
	      }
	
	      return {
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut,
	        onMouseDown: function onMouseDown(e) {
	          _this4.touchObject = {
	            startX: e.clientX,
	            startY: e.clientY
	          };
	
	          _this4.setState({
	            dragging: true
	          });
	        },
	        onMouseMove: function onMouseMove(e) {
	          if (!_this4.state.dragging) {
	            return;
	          }
	
	          var direction = (0, _utilities.swipeDirection)(_this4.touchObject.startX, e.clientX, _this4.touchObject.startY, e.clientY, _this4.props.vertical);
	
	          if (direction !== 0) {
	            e.preventDefault();
	          }
	
	          var length = _this4.props.vertical ? Math.round(Math.sqrt(Math.pow(e.clientY - _this4.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.clientX - _this4.touchObject.startX, 2))); // prevents disabling click just because mouse moves a fraction of a pixel
	
	          if (length >= 10) {
	            if (_this4.clickDisabled === false) _this4.props.onDragStart(e);
	            _this4.clickDisabled = true;
	          }
	
	          _this4.touchObject = {
	            startX: _this4.touchObject.startX,
	            startY: _this4.touchObject.startY,
	            endX: e.clientX,
	            endY: e.clientY,
	            length: length,
	            direction: direction
	          };
	
	          _this4.setState({
	            left: _this4.props.vertical ? 0 : _this4.getTargetLeft(_this4.touchObject.length * _this4.touchObject.direction),
	            top: _this4.props.vertical ? _this4.getTargetLeft(_this4.touchObject.length * _this4.touchObject.direction) : 0
	          });
	        },
	        onMouseUp: function onMouseUp(e) {
	          if (_this4.touchObject.length === 0 || _this4.touchObject.length === undefined) {
	            _this4.setState({
	              dragging: false
	            });
	
	            return;
	          }
	
	          _this4.handleSwipe(e);
	        },
	        onMouseLeave: function onMouseLeave(e) {
	          if (!_this4.state.dragging) {
	            return;
	          }
	
	          _this4.handleSwipe(e);
	        }
	      };
	    }
	  }, {
	    key: "pauseAutoplay",
	    value: function pauseAutoplay() {
	      if (this.props.autoplay) {
	        this.autoplayPaused = true;
	        this.stopAutoplay();
	      }
	    }
	  }, {
	    key: "unpauseAutoplay",
	    value: function unpauseAutoplay() {
	      if (this.props.autoplay && this.autoplayPaused) {
	        this.startAutoplay();
	        this.autoplayPaused = null;
	      }
	    }
	  }, {
	    key: "handleMouseOver",
	    value: function handleMouseOver() {
	      if (this.props.pauseOnHover) {
	        this.pauseAutoplay();
	      }
	    }
	  }, {
	    key: "handleMouseOut",
	    value: function handleMouseOut() {
	      if (this.autoplayPaused) {
	        this.unpauseAutoplay();
	      }
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(event) {
	      if (this.clickDisabled === true) {
	        if (event.metaKey || event.shiftKey || event.altKey || event.ctrlKey) {
	          return;
	        }
	
	        event.preventDefault();
	        event.stopPropagation();
	
	        if (event.nativeEvent) {
	          event.nativeEvent.stopPropagation();
	        }
	      }
	    }
	  }, {
	    key: "handleSwipe",
	    value: function handleSwipe() {
	      var _this5 = this;
	
	      var slidesToShow = this.state.slidesToShow;
	
	      if (this.props.slidesToScroll === 'auto') {
	        slidesToShow = this.state.slidesToScroll;
	      }
	
	      if (this.touchObject.length > this.state.slideWidth / slidesToShow / 5) {
	        if (this.touchObject.direction === 1) {
	          if (this.state.currentSlide + 1 >= this.state.slideCount && !this.props.wrapAround) {
	            this.setState({
	              easing: easing[this.props.edgeEasing]
	            });
	          } else {
	            this.nextSlide();
	          }
	        } else if (this.touchObject.direction === -1) {
	          if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
	            this.setState({
	              easing: easing[this.props.edgeEasing]
	            });
	          } else {
	            this.previousSlide();
	          }
	        }
	      } else {
	        this.goToSlide(this.state.currentSlide);
	      } // wait for `handleClick` event before resetting clickDisabled
	
	
	      this.timers.push(setTimeout(function () {
	        _this5.clickDisabled = false;
	      }, 0));
	      this.touchObject = {};
	      this.setState({
	        dragging: false
	      });
	    } // eslint-disable-next-line complexity
	
	  }, {
	    key: "handleKeyPress",
	    value: function handleKeyPress(e) {
	      if (this.props.enableKeyboardControls) {
	        switch (e.keyCode) {
	          case 39:
	          case 68:
	          case 38:
	          case 87:
	            this.nextSlide();
	            break;
	
	          case 37:
	          case 65:
	          case 40:
	          case 83:
	            this.previousSlide();
	            break;
	
	          case 81:
	            this.goToSlide(0, this.props);
	            break;
	
	          case 69:
	            this.goToSlide(this.state.slideCount - 1, this.props);
	            break;
	
	          case 32:
	            if (this.state.pauseOnHover && this.props.autoplay) {
	              this.setState({
	                pauseOnHover: false
	              });
	              this.pauseAutoplay();
	              break;
	            } else {
	              this.setState({
	                pauseOnHover: true
	              });
	              this.unpauseAutoplay();
	              break;
	            }
	
	        }
	      }
	    }
	  }, {
	    key: "autoplayIterator",
	    value: function autoplayIterator() {
	      if (this.props.wrapAround) {
	        if (this.props.autoplayReverse) {
	          this.previousSlide();
	        } else {
	          this.nextSlide();
	        }
	
	        return;
	      }
	
	      if (this.props.autoplayReverse) {
	        if (this.state.currentSlide !== 0) {
	          this.previousSlide();
	        } else {
	          this.stopAutoplay();
	        }
	      } else if (this.state.currentSlide !== this.state.slideCount - this.state.slidesToShow) {
	        this.nextSlide();
	      } else {
	        this.stopAutoplay();
	      }
	    }
	  }, {
	    key: "startAutoplay",
	    value: function startAutoplay() {
	      this.autoplayID = setInterval(this.autoplayIterator, this.props.autoplayInterval);
	    }
	  }, {
	    key: "resetAutoplay",
	    value: function resetAutoplay() {
	      if (this.props.autoplay && !this.autoplayPaused) {
	        this.stopAutoplay();
	        this.startAutoplay();
	      }
	    }
	  }, {
	    key: "stopAutoplay",
	    value: function stopAutoplay() {
	      if (this.autoplayID) {
	        clearInterval(this.autoplayID);
	      }
	    } // Animation Method
	
	  }, {
	    key: "getTargetLeft",
	    value: function getTargetLeft(touchOffset, slide) {
	      var offset;
	      var target = slide || this.state.currentSlide;
	
	      switch (this.state.cellAlign) {
	        case 'left':
	          {
	            offset = 0;
	            offset -= this.props.cellSpacing * target;
	            break;
	          }
	
	        case 'center':
	          {
	            offset = (this.state.frameWidth - this.state.slideWidth) / 2;
	            offset -= this.props.cellSpacing * target;
	            break;
	          }
	
	        case 'right':
	          {
	            offset = this.state.frameWidth - this.state.slideWidth;
	            offset -= this.props.cellSpacing * target;
	            break;
	          }
	      }
	
	      var left = this.state.slideWidth * target;
	      var lastSlide = this.state.currentSlide > 0 && target + this.state.slidesToScroll >= this.state.slideCount;
	
	      if (lastSlide && this.props.slideWidth !== 1 && !this.props.wrapAround && this.props.slidesToScroll === 'auto') {
	        left = this.state.slideWidth * this.state.slideCount - this.state.frameWidth;
	        offset = 0;
	        offset -= this.props.cellSpacing * (this.state.slideCount - 1);
	      }
	
	      offset -= touchOffset || 0;
	      return (left - offset) * -1;
	    }
	  }, {
	    key: "getOffsetDeltas",
	    value: function getOffsetDeltas() {
	      var offset = 0;
	
	      if (this.state.isWrappingAround) {
	        offset = this.getTargetLeft(null, this.state.wrapToIndex);
	      } else {
	        offset = this.getTargetLeft(this.touchObject.length * this.touchObject.direction);
	      }
	
	      return {
	        tx: [this.props.vertical ? 0 : offset],
	        ty: [this.props.vertical ? offset : 0]
	      };
	    }
	  }, {
	    key: "isEdgeSwiping",
	    value: function isEdgeSwiping() {
	      var _this$state = this.state,
	          slideCount = _this$state.slideCount,
	          slideWidth = _this$state.slideWidth,
	          slideHeight = _this$state.slideHeight,
	          slidesToShow = _this$state.slidesToShow;
	
	      var _this$getOffsetDeltas = this.getOffsetDeltas(),
	          tx = _this$getOffsetDeltas.tx,
	          ty = _this$getOffsetDeltas.ty;
	
	      if (this.props.vertical) {
	        var rowHeight = slideHeight / slidesToShow;
	        var slidesLeftToShow = slideCount - slidesToShow;
	        var lastSlideLimit = rowHeight * slidesLeftToShow; // returns true if ty offset is outside first or last slide
	
	        return ty > 0 || -ty > lastSlideLimit;
	      } // returns true if tx offset is outside first or last slide
	
	
	      return tx > 0 || -tx > slideWidth * (slideCount - 1);
	    } // Action Methods
	
	  }, {
	    key: "goToSlide",
	    value: function goToSlide(index, props) {
	      var _this6 = this;
	
	      if (props === undefined) {
	        props = this.props;
	      }
	
	      if (this.isTransitioning) {
	        return;
	      }
	
	      this.setState({
	        hasInteraction: true,
	        easing: easing[props.easing]
	      });
	      this.isTransitioning = true;
	      var previousSlide = this.state.currentSlide;
	
	      if (index >= this.state.slideCount || index < 0) {
	        if (!props.wrapAround) {
	          this.isTransitioning = false;
	          return;
	        }
	
	        if (index >= this.state.slideCount) {
	          props.beforeSlide(this.state.currentSlide, 0);
	          this.setState(function (prevState) {
	            return {
	              left: props.vertical ? 0 : _this6.getTargetLeft(_this6.state.slideWidth, prevState.currentSlide),
	              top: props.vertical ? _this6.getTargetLeft(_this6.state.slideWidth, prevState.currentSlide) : 0,
	              currentSlide: 0,
	              isWrappingAround: true,
	              wrapToIndex: _this6.state.slideCount
	            };
	          }, function () {
	            _this6.timers.push(setTimeout(function () {
	              _this6.resetAutoplay();
	
	              _this6.isTransitioning = false;
	
	              if (index !== previousSlide) {
	                _this6.props.afterSlide(0);
	              }
	            }, props.speed));
	          });
	          return;
	        } else {
	          var endSlide = index < 0 ? this.state.slideCount + index : this.state.slideCount - this.state.slidesToScroll;
	          props.beforeSlide(this.state.currentSlide, endSlide);
	          this.setState(function (prevState) {
	            return {
	              left: props.vertical ? 0 : _this6.getTargetLeft(0, prevState.currentSlide),
	              top: props.vertical ? _this6.getTargetLeft(0, prevState.currentSlide) : 0,
	              currentSlide: endSlide,
	              isWrappingAround: true,
	              wrapToIndex: index
	            };
	          }, function () {
	            _this6.timers.push(setTimeout(function () {
	              _this6.resetAutoplay();
	
	              _this6.isTransitioning = false;
	
	              if (index !== previousSlide) {
	                _this6.props.afterSlide(_this6.state.slideCount - 1);
	              }
	            }, props.speed));
	          });
	          return;
	        }
	      }
	
	      this.props.beforeSlide(this.state.currentSlide, index);
	      this.setState({
	        currentSlide: index
	      }, function () {
	        return _this6.timers.push(setTimeout(function () {
	          _this6.resetAutoplay();
	
	          _this6.isTransitioning = false;
	
	          if (index !== previousSlide) {
	            _this6.props.afterSlide(index);
	          }
	        }, props.speed));
	      });
	    }
	  }, {
	    key: "nextSlide",
	    value: function nextSlide() {
	      var childrenCount = this.state.slideCount;
	      var slidesToShow = this.state.slidesToShow;
	
	      if (this.props.slidesToScroll === 'auto') {
	        slidesToShow = this.state.slidesToScroll;
	      }
	
	      if (this.state.currentSlide >= childrenCount - slidesToShow && !this.props.wrapAround && this.props.cellAlign === 'left') {
	        return;
	      }
	
	      if (this.props.wrapAround) {
	        this.goToSlide(this.state.currentSlide + this.state.slidesToScroll);
	      } else {
	        if (this.props.slideWidth !== 1) {
	          this.goToSlide(this.state.currentSlide + this.state.slidesToScroll);
	          return;
	        }
	
	        var offset = this.state.currentSlide + this.state.slidesToScroll;
	        var nextSlideIndex = this.props.cellAlign !== 'left' ? offset : Math.min(offset, childrenCount - slidesToShow);
	        this.goToSlide(nextSlideIndex);
	      }
	    }
	  }, {
	    key: "previousSlide",
	    value: function previousSlide() {
	      if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
	        return;
	      }
	
	      if (this.props.wrapAround) {
	        this.goToSlide(this.state.currentSlide - this.state.slidesToScroll);
	      } else {
	        this.goToSlide(Math.max(0, this.state.currentSlide - this.state.slidesToScroll));
	      }
	    } // Bootstrapping
	
	  }, {
	    key: "bindEvents",
	    value: function bindEvents() {
	      if (_exenv["default"].canUseDOM) {
	        (0, _utilities.addEvent)(window, 'resize', this.onResize);
	        (0, _utilities.addEvent)(document, 'readystatechange', this.onReadyStateChange);
	        (0, _utilities.addEvent)(document, 'visibilitychange', this.onVisibilityChange);
	        (0, _utilities.addEvent)(document, 'keydown', this.handleKeyPress);
	      }
	    }
	  }, {
	    key: "onResize",
	    value: function onResize() {
	      this.setDimensions(null, this.props.onResize);
	    }
	  }, {
	    key: "onReadyStateChange",
	    value: function onReadyStateChange() {
	      // When using dynamic content in a slide, it is possible that `readystatechange` will fire before the component has finished mounting, which means `this.state.slideHeight` remains 0, instead of the correct height. Tracking this in state will trigger `componentDidUpdate` which can set the correct height.
	      // See #521 and https://github.com/FormidableLabs/nuka-carousel/blob/fea63242a8b2fb69c65689efe615d0feb9b2d1ff/README.md#resizing-height-issue
	      this.setState({
	        readyStateChanged: this.state.readyStateChanged + 1
	      });
	      this.setDimensions();
	    }
	  }, {
	    key: "onVisibilityChange",
	    value: function onVisibilityChange() {
	      if (document.hidden) {
	        this.pauseAutoplay();
	      } else {
	        this.unpauseAutoplay();
	      }
	    }
	  }, {
	    key: "unbindEvents",
	    value: function unbindEvents() {
	      if (_exenv["default"].canUseDOM) {
	        (0, _utilities.removeEvent)(window, 'resize', this.onResize);
	        (0, _utilities.removeEvent)(document, 'readystatechange', this.onReadyStateChange);
	        (0, _utilities.removeEvent)(document, 'visibilitychange', this.onVisibilityChange);
	        (0, _utilities.removeEvent)(document, 'keydown', this.handleKeyPress);
	      }
	    }
	  }, {
	    key: "calcSlideHeightAndWidth",
	    value: function calcSlideHeightAndWidth(props) {
	      // slide height
	      props = props || this.props;
	      var childNodes = this.getChildNodes();
	      var slideHeight = (0, _bootstrappingUtilities.getSlideHeight)(props, this.state, childNodes); //slide width
	
	      var _getPropsByTransition = (0, _utilities.getPropsByTransitionMode)(props, ['slidesToShow']),
	          slidesToShow = _getPropsByTransition.slidesToShow;
	
	      var frame = this.frame;
	      var slideWidth;
	
	      if (this.props.animation === 'zoom') {
	        slideWidth = frame.offsetWidth - frame.offsetWidth * 15 / 100;
	      } else if (typeof props.slideWidth !== 'number') {
	        slideWidth = parseInt(props.slideWidth);
	      } else if (props.vertical) {
	        slideWidth = slideHeight / slidesToShow * props.slideWidth;
	      } else {
	        slideWidth = frame.offsetWidth / slidesToShow * props.slideWidth;
	      }
	
	      if (!props.vertical) {
	        slideWidth -= props.cellSpacing * ((100 - 100 / slidesToShow) / 100);
	      }
	
	      return {
	        slideHeight: slideHeight,
	        slideWidth: slideWidth
	      };
	    }
	  }, {
	    key: "setSlideHeightAndWidth",
	    value: function setSlideHeightAndWidth() {
	      this.setState(this.calcSlideHeightAndWidth());
	    }
	  }, {
	    key: "setDimensions",
	    value: function setDimensions(props) {
	      var _this7 = this;
	
	      var stateCb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	      props = props || this.props;
	
	      var _getPropsByTransition2 = (0, _utilities.getPropsByTransitionMode)(props, ['slidesToShow', 'cellAlign']),
	          slidesToShow = _getPropsByTransition2.slidesToShow,
	          cellAlign = _getPropsByTransition2.cellAlign;
	
	      var frame = this.frame;
	
	      var _this$calcSlideHeight2 = this.calcSlideHeightAndWidth(props),
	          slideHeight = _this$calcSlideHeight2.slideHeight,
	          slideWidth = _this$calcSlideHeight2.slideWidth;
	
	      var frameHeight = slideHeight + props.cellSpacing * (slidesToShow - 1);
	      var frameWidth = props.vertical ? frameHeight : frame.offsetWidth;
	
	      var _getPropsByTransition3 = (0, _utilities.getPropsByTransitionMode)(props, ['slidesToScroll']),
	          slidesToScroll = _getPropsByTransition3.slidesToScroll;
	
	      if (slidesToScroll === 'auto') {
	        slidesToScroll = Math.floor(frameWidth / (slideWidth + props.cellSpacing));
	      }
	
	      this.setState({
	        frameWidth: frameWidth,
	        slideHeight: slideHeight,
	        slidesToScroll: slidesToScroll,
	        slidesToShow: slidesToShow,
	        slideWidth: slideWidth,
	        cellAlign: cellAlign,
	        left: props.vertical ? 0 : this.getTargetLeft(),
	        top: props.vertical ? this.getTargetLeft() : 0
	      }, function () {
	        stateCb();
	
	        _this7.setLeft();
	      });
	    }
	  }, {
	    key: "getChildNodes",
	    value: function getChildNodes() {
	      return this.frame.childNodes[0].childNodes;
	    }
	  }, {
	    key: "getCurrentChildNodeImg",
	    value: function getCurrentChildNodeImg() {
	      var childNodes = this.getChildNodes();
	      var currentChildNode = childNodes[this.props.slideIndex];
	      return currentChildNode ? currentChildNode.getElementsByTagName('img')[0] : null;
	    }
	  }, {
	    key: "setLeft",
	    value: function setLeft() {
	      var newLeft = this.props.vertical ? 0 : this.getTargetLeft();
	      var newTop = this.props.vertical ? this.getTargetLeft() : 0;
	
	      if (newLeft !== this.state.left || newTop !== this.state.top) {
	        this.setState({
	          left: newLeft,
	          top: newTop
	        });
	      }
	    }
	  }, {
	    key: "renderControls",
	    value: function renderControls() {
	      var _this8 = this;
	
	      if (this.props.withoutControls) {
	        return this.controlsMap.map(function () {
	          return null;
	        });
	      } else {
	        return this.controlsMap.map(function (_ref) {
	          var funcName = _ref.funcName,
	              key = _ref.key;
	          var func = _this8.props[funcName];
	          var controlChildren = func && typeof func === 'function' && func({
	            cellAlign: _this8.props.cellAlign,
	            cellSpacing: _this8.props.cellSpacing,
	            currentSlide: _this8.state.currentSlide,
	            frameWidth: _this8.state.frameWidth,
	            goToSlide: function goToSlide(index) {
	              return _this8.goToSlide(index);
	            },
	            nextSlide: function nextSlide() {
	              return _this8.nextSlide();
	            },
	            previousSlide: function previousSlide() {
	              return _this8.previousSlide();
	            },
	            slideCount: _this8.state.slideCount,
	            slidesToScroll: _this8.state.slidesToScroll,
	            slidesToShow: _this8.state.slidesToShow,
	            slideWidth: _this8.state.slideWidth,
	            wrapAround: _this8.props.wrapAround
	          });
	          return controlChildren && _react["default"].createElement("div", {
	            className: "slider-control-".concat(key.toLowerCase()),
	            style: (0, _styleUtilities.getDecoratorStyles)(key),
	            key: key
	          }, controlChildren);
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this9 = this;
	
	      var _this$state2 = this.state,
	          currentSlide = _this$state2.currentSlide,
	          slideCount = _this$state2.slideCount,
	          frameWidth = _this$state2.frameWidth;
	      var _this$props = this.props,
	          frameOverflow = _this$props.frameOverflow,
	          vertical = _this$props.vertical,
	          framePadding = _this$props.framePadding,
	          slidesToShow = _this$props.slidesToShow,
	          renderAnnounceSlideMessage = _this$props.renderAnnounceSlideMessage,
	          disableAnimation = _this$props.disableAnimation;
	      var duration = this.state.dragging || !this.state.dragging && this.state.resetWrapAroundPosition && this.props.wrapAround || disableAnimation || !this.state.hasInteraction ? 0 : this.props.speed;
	      var frameStyles = (0, _styleUtilities.getFrameStyles)(frameOverflow, vertical, framePadding, frameWidth);
	      var touchEvents = this.getTouchEvents();
	      var mouseEvents = this.getMouseEvents();
	      var TransitionControl = _allTransitions["default"][this.props.transitionMode];
	      var validChildren = (0, _bootstrappingUtilities.getValidChildren)(this.props.children);
	      return _react["default"].createElement("div", {
	        className: ['slider', this.props.className || ''].join(' '),
	        style: _extends({}, (0, _styleUtilities.getSliderStyles)(this.props.width, this.props.height), this.props.style)
	      }, !this.props.autoplay && _react["default"].createElement(_announceSlide["default"], {
	        message: renderAnnounceSlideMessage({
	          currentSlide: currentSlide,
	          slideCount: slideCount
	        })
	      }), _react["default"].createElement("div", _extends({
	        className: "slider-frame",
	        ref: function ref(frame) {
	          return _this9.frame = frame;
	        },
	        style: frameStyles
	      }, touchEvents, mouseEvents, {
	        onClickCapture: this.handleClick
	      }), _react["default"].createElement(_Animate["default"], {
	        show: true,
	        start: {
	          tx: 0,
	          ty: 0
	        },
	        update: function update() {
	          var _this9$getOffsetDelta = _this9.getOffsetDeltas(),
	              tx = _this9$getOffsetDelta.tx,
	              ty = _this9$getOffsetDelta.ty;
	
	          if (_this9.props.disableEdgeSwiping && !_this9.props.wrapAround && _this9.isEdgeSwiping()) {
	            return {};
	          } else {
	            return {
	              tx: tx,
	              ty: ty,
	              timing: {
	                duration: duration,
	                ease: _this9.state.easing
	              },
	              events: {
	                end: function end() {
	                  var newLeft = _this9.props.vertical ? 0 : _this9.getTargetLeft();
	                  var newTop = _this9.props.vertical ? _this9.getTargetLeft() : 0;
	
	                  if (newLeft !== _this9.state.left || newTop !== _this9.state.top) {
	                    _this9.setState({
	                      left: newLeft,
	                      top: newTop,
	                      isWrappingAround: false,
	                      resetWrapAroundPosition: true
	                    }, function () {
	                      _this9.setState({
	                        resetWrapAroundPosition: false
	                      });
	                    });
	                  }
	                }
	              }
	            };
	          }
	        },
	        children: function children(_ref2) {
	          var tx = _ref2.tx,
	              ty = _ref2.ty;
	          return _react["default"].createElement(TransitionControl, _extends({}, (0, _styleUtilities.getTransitionProps)(_this9.props, _this9.state), {
	            deltaX: tx,
	            deltaY: ty
	          }), (0, _bootstrappingUtilities.addAccessibility)(validChildren, slidesToShow, currentSlide));
	        }
	      })), this.renderControls(), this.props.autoGenerateStyleTag && _react["default"].createElement("style", {
	        type: "text/css",
	        dangerouslySetInnerHTML: {
	          __html: (0, _styleUtilities.getImgTagStyles)()
	        }
	      }));
	    }
	  }]);
	
	  return Carousel;
	}(_react["default"].Component);
	
	exports["default"] = Carousel;
	Carousel.propTypes = {
	  afterSlide: _propTypes["default"].func,
	  animation: _propTypes["default"].oneOf(['zoom']),
	  autoGenerateStyleTag: _propTypes["default"].bool,
	  autoplay: _propTypes["default"].bool,
	  autoplayInterval: _propTypes["default"].number,
	  autoplayReverse: _propTypes["default"].bool,
	  beforeSlide: _propTypes["default"].func,
	  cellAlign: _propTypes["default"].oneOf(['left', 'center', 'right']),
	  cellSpacing: _propTypes["default"].number,
	  enableKeyboardControls: _propTypes["default"].bool,
	  disableAnimation: _propTypes["default"].bool,
	  disableEdgeSwiping: _propTypes["default"].bool,
	  dragging: _propTypes["default"].bool,
	  easing: _propTypes["default"].string,
	  edgeEasing: _propTypes["default"].string,
	  frameOverflow: _propTypes["default"].string,
	  framePadding: _propTypes["default"].string,
	  height: _propTypes["default"].string,
	  heightMode: _propTypes["default"].oneOf(['first', 'current', 'max']),
	  initialSlideHeight: _propTypes["default"].number,
	  initialSlideWidth: _propTypes["default"].number,
	  onDragStart: _propTypes["default"].func,
	  onResize: _propTypes["default"].func,
	  pauseOnHover: _propTypes["default"].bool,
	  renderAnnounceSlideMessage: _propTypes["default"].func,
	  renderBottomCenterControls: _propTypes["default"].func,
	  renderBottomLeftControls: _propTypes["default"].func,
	  renderBottomRightControls: _propTypes["default"].func,
	  renderCenterCenterControls: _propTypes["default"].func,
	  renderCenterLeftControls: _propTypes["default"].func,
	  renderCenterRightControls: _propTypes["default"].func,
	  renderTopCenterControls: _propTypes["default"].func,
	  renderTopLeftControls: _propTypes["default"].func,
	  renderTopRightControls: _propTypes["default"].func,
	  slideIndex: _propTypes["default"].number,
	  slideOffset: _propTypes["default"].number,
	  slidesToScroll: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].oneOf(['auto'])]),
	  slidesToShow: _propTypes["default"].number,
	  slideWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  speed: _propTypes["default"].number,
	  swiping: _propTypes["default"].bool,
	  transitionMode: _propTypes["default"].oneOf(['scroll', 'fade', 'scroll3d']),
	  vertical: _propTypes["default"].bool,
	  width: _propTypes["default"].string,
	  withoutControls: _propTypes["default"].bool,
	  wrapAround: _propTypes["default"].bool,
	  opacityScale: _propTypes["default"].number,
	  slideListMargin: _propTypes["default"].number
	};
	Carousel.defaultProps = {
	  afterSlide: function afterSlide() {},
	  autoGenerateStyleTag: true,
	  autoplay: false,
	  autoplayInterval: 3000,
	  autoplayReverse: false,
	  beforeSlide: function beforeSlide() {},
	  cellAlign: 'left',
	  cellSpacing: 0,
	  enableKeyboardControls: false,
	  disableAnimation: false,
	  disableEdgeSwiping: false,
	  dragging: true,
	  easing: 'easeCircleOut',
	  edgeEasing: 'easeElasticOut',
	  frameOverflow: 'hidden',
	  framePadding: '0px',
	  height: 'inherit',
	  heightMode: 'max',
	  onDragStart: function onDragStart() {},
	  onResize: function onResize() {},
	  pauseOnHover: true,
	  renderAnnounceSlideMessage: _announceSlide.defaultRenderAnnounceSlideMessage,
	  renderBottomCenterControls: function renderBottomCenterControls(props) {
	    return _react["default"].createElement(_defaultControls.PagingDots, props);
	  },
	  renderCenterLeftControls: function renderCenterLeftControls(props) {
	    return _react["default"].createElement(_defaultControls.PreviousButton, props);
	  },
	  renderCenterRightControls: function renderCenterRightControls(props) {
	    return _react["default"].createElement(_defaultControls.NextButton, props);
	  },
	  slideIndex: 0,
	  slideOffset: 25,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  slideWidth: 1,
	  speed: 500,
	  style: {},
	  swiping: true,
	  transitionMode: 'scroll',
	  vertical: false,
	  width: '100%',
	  withoutControls: false,
	  wrapAround: false,
	  slideListMargin: 10
	};

/***/ }),

/***/ 1026:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var MIN_ZOOM_SCALE = 0;
	var MAX_ZOOM_SCALE = 1;
	
	var ScrollTransition3D =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(ScrollTransition3D, _React$Component);
	
	  function ScrollTransition3D(props) {
	    var _this;
	
	    _classCallCheck(this, ScrollTransition3D);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(ScrollTransition3D).call(this, props));
	    _this.getListStyles = _this.getListStyles.bind(_assertThisInitialized(_this));
	    return _this;
	  }
	
	  _createClass(ScrollTransition3D, [{
	    key: "getSlideDirection",
	    value: function getSlideDirection(start, end, isWrapping) {
	      var direction = 0;
	      if (start === end) return direction;
	
	      if (isWrapping) {
	        direction = start < end ? -1 : 1;
	      } else {
	        direction = start < end ? 1 : -1;
	      }
	
	      return direction;
	    }
	    /* eslint-disable complexity */
	
	  }, {
	    key: "getSlideTargetPosition",
	    value: function getSlideTargetPosition(index) {
	      var targetPosition = 0;
	      var offset = 0;
	
	      if (index !== this.props.currentSlide) {
	        var relativeDistanceToCurrentSlide = this.getRelativeDistanceToCurrentSlide(index);
	        targetPosition = (this.props.slideWidth + this.props.cellSpacing) * relativeDistanceToCurrentSlide - this.getZoomOffsetFor(relativeDistanceToCurrentSlide);
	        offset = 0;
	
	        if (this.props.animation === 'zoom' && (this.props.currentSlide === index + 1 || this.props.currentSlide === 0 && index === this.props.children.length - 1)) {
	          offset = this.props.slideOffset;
	        } else if (this.props.animation === 'zoom' && (this.props.currentSlide === index - 1 || this.props.currentSlide === this.props.children.length - 1 && index === 0)) {
	          offset = -this.props.slideOffset;
	        }
	      }
	
	      return targetPosition + offset;
	    }
	    /* eslint-enable complexity */
	
	  }, {
	    key: "formatChildren",
	    value: function formatChildren(children) {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          top = _this$props.top,
	          left = _this$props.left,
	          currentSlide = _this$props.currentSlide,
	          slidesToShow = _this$props.slidesToShow;
	      var positionValue = this.props.vertical ? top : left;
	      return _react["default"].Children.map(children, function (child, index) {
	        var visible = _this2.getDistanceToCurrentSlide(index) <= slidesToShow / 2;
	        var current = currentSlide === index;
	        return _react["default"].createElement("li", {
	          className: "slider-slide".concat(visible ? ' slide-visible' : '').concat(current ? ' slide-current' : ''),
	          style: _this2.getSlideStyles(index, positionValue),
	          key: index
	        }, child);
	      });
	    }
	  }, {
	    key: "getZoomOffsetFor",
	    value: function getZoomOffsetFor(relativeDistanceToCurrent) {
	      if (relativeDistanceToCurrent === 0) {
	        return 0;
	      }
	
	      var marginGeneratedByZoom = (1 - Math.pow(this.props.zoomScale, Math.abs(relativeDistanceToCurrent))) * this.props.slideWidth;
	      var direction = relativeDistanceToCurrent < 0 ? -1 : 1;
	      var result = marginGeneratedByZoom * direction + this.getZoomOffsetFor(relativeDistanceToCurrent < 0 ? relativeDistanceToCurrent + 1 : relativeDistanceToCurrent - 1);
	      return result;
	    }
	  }, {
	    key: "getDistance",
	    value: function getDistance(index, referenceIndex) {
	      return Math.abs(index - referenceIndex);
	    }
	  }, {
	    key: "getDistanceToCurrentSlide",
	    value: function getDistanceToCurrentSlide(index) {
	      return this.props.wrapAround ? Math.min(Math.min(this.getDistance(index, 0) + this.getDistance(this.props.currentSlide, this.props.slideCount), this.getDistance(index, this.props.slideCount) + this.getDistance(this.props.currentSlide, 0)), this.getDistance(index, this.props.currentSlide)) : this.getDistance(index, this.props.currentSlide);
	    }
	  }, {
	    key: "getRelativeDistanceToCurrentSlide",
	    value: function getRelativeDistanceToCurrentSlide(index) {
	      if (this.props.wrapAround) {
	        var distanceByLeftEge = this.getDistance(index, 0) + this.getDistance(this.props.currentSlide, this.props.slideCount);
	        var distanceByRightEdge = this.getDistance(index, this.props.slideCount) + this.getDistance(this.props.currentSlide, 0);
	        var absoluteDirectDistance = this.getDistance(index, this.props.currentSlide);
	        var minimumDistance = Math.min(Math.min(distanceByLeftEge, distanceByRightEdge), absoluteDirectDistance);
	
	        switch (minimumDistance) {
	          case absoluteDirectDistance:
	            return index - this.props.currentSlide;
	
	          case distanceByLeftEge:
	            return distanceByLeftEge;
	
	          case distanceByRightEdge:
	            return -distanceByRightEdge;
	
	          default:
	            return 0;
	        }
	      } else {
	        return index - this.props.currentSlide;
	      }
	    }
	  }, {
	    key: "getTransformScale",
	    value: function getTransformScale(index) {
	      return this.props.currentSlide !== index ? Math.max(Math.min(Math.pow(this.props.zoomScale, this.getDistanceToCurrentSlide(index)), MAX_ZOOM_SCALE), MIN_ZOOM_SCALE) : 1.0;
	    }
	  }, {
	    key: "getOpacityScale",
	    value: function getOpacityScale(index) {
	      return this.props.currentSlide !== index ? Math.max(Math.min(Math.pow(this.props.opacityScale, this.getDistanceToCurrentSlide(index)), MAX_ZOOM_SCALE), MIN_ZOOM_SCALE) : 1.0;
	    }
	  }, {
	    key: "getSlideStyles",
	    value: function getSlideStyles(index, positionValue) {
	      var targetPosition = this.getSlideTargetPosition(index, positionValue);
	      var transformScale = this.getTransformScale(index);
	      return {
	        zIndex: this.props.slideCount - this.getDistanceToCurrentSlide(index),
	        boxSizing: 'border-box',
	        display: this.props.vertical ? 'block' : 'inline-block',
	        height: 'auto',
	        left: this.props.vertical ? 0 : targetPosition,
	        listStyleType: 'none',
	        marginBottom: this.props.vertical ? this.props.cellSpacing / 2 : 'auto',
	        marginLeft: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
	        marginRight: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
	        marginTop: this.props.vertical ? this.props.cellSpacing / 2 : 'auto',
	        MozBoxSizing: 'border-box',
	        position: 'absolute',
	        top: this.props.vertical ? targetPosition : 0,
	        transform: "scale(".concat(transformScale, ")"),
	        transition: 'left 0.4s ease-out, transform 0.4s ease-out, opacity 0.4s ease-out',
	        verticalAlign: 'top',
	        width: this.props.vertical ? '100%' : this.props.slideWidth,
	        opacity: this.getOpacityScale(index)
	      };
	    }
	  }, {
	    key: "getListStyles",
	    value: function getListStyles() {
	      var listWidth = this.props.slideWidth * _react["default"].Children.count(this.props.children);
	
	      var spacingOffset = this.props.cellSpacing * _react["default"].Children.count(this.props.children);
	
	      return {
	        left: "calc(50% - (".concat(this.props.slideWidth, "px / 2))"),
	        position: 'relative',
	        margin: this.props.vertical ? "".concat(this.props.cellSpacing / 2 * -1, "px 0px") : "".concat(this.props.slideListMargin, "px ").concat(this.props.cellSpacing / 2 * -1, "px"),
	        padding: 0,
	        height: this.props.vertical ? listWidth + spacingOffset : this.props.slideHeight,
	        width: this.props.vertical ? 'auto' : '100%',
	        cursor: this.props.dragging === true ? 'pointer' : 'inherit',
	        boxSizing: 'border-box',
	        MozBoxSizing: 'border-box',
	        touchAction: "pinch-zoom ".concat(this.props.vertical ? 'pan-x' : 'pan-y')
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var children = this.formatChildren(this.props.children);
	      return _react["default"].createElement("ul", {
	        className: "slider-list",
	        style: this.getListStyles()
	      }, children);
	    }
	  }]);
	
	  return ScrollTransition3D;
	}(_react["default"].Component);
	
	exports["default"] = ScrollTransition3D;
	ScrollTransition3D.propTypes = {
	  cellSpacing: _propTypes["default"].number,
	  currentSlide: _propTypes["default"].number,
	  dragging: _propTypes["default"].bool,
	  isWrappingAround: _propTypes["default"].bool,
	  left: _propTypes["default"].number,
	  slideCount: _propTypes["default"].number,
	  slideHeight: _propTypes["default"].number,
	  slideOffset: _propTypes["default"].number,
	  slideWidth: _propTypes["default"].number,
	  top: _propTypes["default"].number,
	  vertical: _propTypes["default"].bool,
	  wrapAround: _propTypes["default"].bool,
	  zoomScale: _propTypes["default"].number,
	  opacityScale: _propTypes["default"].number,
	  slidesToShow: _propTypes["default"].number,
	  slideListMargin: _propTypes["default"].number
	};
	ScrollTransition3D.defaultProps = {
	  cellSpacing: 0,
	  currentSlide: 0,
	  dragging: false,
	  isWrappingAround: false,
	  left: 0,
	  slideCount: 0,
	  slideHeight: 0,
	  slideWidth: 0,
	  top: 0,
	  vertical: false,
	  wrapAround: true,
	  zoomScale: 0.75,
	  opacityScale: 0.65,
	  slidesToShow: 3,
	  slideListMargin: 10
	};

/***/ }),

/***/ 1027:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var FadeTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(FadeTransition, _React$Component);
	
	  function FadeTransition(props) {
	    var _this;
	
	    _classCallCheck(this, FadeTransition);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(FadeTransition).call(this, props));
	    _this.fadeFromSlide = props.currentSlide;
	    return _this;
	  }
	
	  _createClass(FadeTransition, [{
	    key: "formatChildren",
	    value: function formatChildren(children, opacity) {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          currentSlide = _this$props.currentSlide,
	          slidesToShow = _this$props.slidesToShow;
	      return _react["default"].Children.map(children, function (child, index) {
	        var visible = index >= currentSlide && index < currentSlide + slidesToShow;
	        return _react["default"].createElement("li", {
	          className: "slider-slide".concat(visible ? ' slide-visible' : ''),
	          style: _this2.getSlideStyles(index, opacity),
	          key: index
	        }, child);
	      });
	    }
	  }, {
	    key: "getSlideOpacityAndLeftMap",
	    value: function getSlideOpacityAndLeftMap(fadeFrom, fadeTo, fade) {
	      // Figure out which position to fade to
	      var fadeToPosition = fadeTo;
	
	      if (fadeFrom > fade && fadeFrom === 0) {
	        fadeToPosition = fadeFrom - this.props.slidesToShow;
	      } else if (fadeFrom < fade && fadeFrom + this.props.slidesToShow > this.props.slideCount - 1) {
	        fadeToPosition = fadeFrom + this.props.slidesToShow;
	      } // Calculate opacity for active slides
	
	
	      var opacity = {};
	
	      if (fadeFrom === fadeTo) {
	        opacity[fadeFrom] = 1;
	      } else {
	        var distance = fadeFrom - fadeToPosition;
	        opacity[fadeFrom] = (fade - fadeToPosition) / distance;
	        opacity[fadeTo] = (fadeFrom - fade) / distance;
	      } // Calculate left for slides and merge in opacity
	
	
	      var map = {};
	
	      for (var i = 0; i < this.props.slidesToShow; i++) {
	        map[fadeFrom + i] = {
	          opacity: opacity[fadeFrom],
	          left: this.props.slideWidth * i
	        };
	        map[fadeTo + i] = {
	          opacity: opacity[fadeTo],
	          left: this.props.slideWidth * i
	        };
	      }
	
	      return map;
	    }
	  }, {
	    key: "getSlideStyles",
	    value: function getSlideStyles(index, data) {
	      return {
	        boxSizing: 'border-box',
	        display: 'block',
	        height: 'auto',
	        left: data[index] ? data[index].left : 0,
	        listStyleType: 'none',
	        marginBottom: 'auto',
	        marginLeft: this.props.cellSpacing / 2,
	        marginRight: this.props.cellSpacing / 2,
	        marginTop: 'auto',
	        MozBoxSizing: 'border-box',
	        opacity: data[index] ? data[index].opacity : 0,
	        position: 'absolute',
	        top: 0,
	        verticalAlign: 'top',
	        visibility: data[index] ? 'inherit' : 'hidden',
	        width: this.props.slideWidth
	      };
	    }
	  }, {
	    key: "getContainerStyles",
	    value: function getContainerStyles() {
	      var width = this.props.slideWidth * this.props.slidesToShow;
	      return {
	        boxSizing: 'border-box',
	        cursor: this.props.dragging === true ? 'pointer' : 'inherit',
	        display: 'block',
	        height: this.props.slideHeight,
	        margin: this.props.vertical ? "".concat(this.props.cellSpacing / 2 * -1, "px 0px") : "0px ".concat(this.props.cellSpacing / 2 * -1, "px"),
	        MozBoxSizing: 'border-box',
	        padding: 0,
	        touchAction: 'none',
	        width: width
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var fade = -(this.props.deltaX || this.props.deltaY) / this.props.slideWidth;
	
	      if (parseInt(fade) === fade) {
	        this.fadeFromSlide = fade;
	      }
	
	      var opacityAndLeftMap = this.getSlideOpacityAndLeftMap(this.fadeFromSlide, this.props.currentSlide, fade);
	      var children = this.formatChildren(this.props.children, opacityAndLeftMap);
	      return _react["default"].createElement("ul", {
	        className: "slider-list",
	        style: this.getContainerStyles()
	      }, children);
	    }
	  }]);
	
	  return FadeTransition;
	}(_react["default"].Component);
	
	exports["default"] = FadeTransition;
	FadeTransition.propTypes = {
	  cellSpacing: _propTypes["default"].number,
	  currentSlide: _propTypes["default"].number,
	  deltaX: _propTypes["default"].number,
	  deltaY: _propTypes["default"].number,
	  dragging: _propTypes["default"].bool,
	  isWrappingAround: _propTypes["default"].bool,
	  left: _propTypes["default"].number,
	  slideCount: _propTypes["default"].number,
	  slideHeight: _propTypes["default"].number,
	  slidesToShow: _propTypes["default"].number,
	  slideWidth: _propTypes["default"].number,
	  top: _propTypes["default"].number,
	  vertical: _propTypes["default"].bool,
	  wrapAround: _propTypes["default"].bool
	};
	FadeTransition.defaultProps = {
	  cellSpacing: 0,
	  currentSlide: 0,
	  deltaX: 0,
	  deltaY: 0,
	  dragging: false,
	  isWrappingAround: false,
	  left: 0,
	  slideCount: 0,
	  slideHeight: 0,
	  slidesToShow: 1,
	  slideWidth: 0,
	  top: 0,
	  vertical: false,
	  wrapAround: false
	};

/***/ }),

/***/ 1028:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var MIN_ZOOM_SCALE = 0;
	var MAX_ZOOM_SCALE = 1;
	
	var ScrollTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(ScrollTransition, _React$Component);
	
	  function ScrollTransition(props) {
	    var _this;
	
	    _classCallCheck(this, ScrollTransition);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(ScrollTransition).call(this, props));
	    _this.getListStyles = _this.getListStyles.bind(_assertThisInitialized(_this));
	    return _this;
	  }
	
	  _createClass(ScrollTransition, [{
	    key: "getSlideDirection",
	    value: function getSlideDirection(start, end, isWrapping) {
	      var direction = 0;
	      if (start === end) return direction;
	
	      if (isWrapping) {
	        direction = start < end ? -1 : 1;
	      } else {
	        direction = start < end ? 1 : -1;
	      }
	
	      return direction;
	    }
	    /* eslint-disable complexity */
	
	  }, {
	    key: "getSlideTargetPosition",
	    value: function getSlideTargetPosition(index, positionValue) {
	      var targetPosition = (this.props.slideWidth + this.props.cellSpacing) * index;
	      var startSlide = Math.min(Math.abs(Math.floor(positionValue / this.props.slideWidth)), this.props.slideCount - 1);
	      var offset = 0;
	
	      if (this.props.animation === 'zoom' && (this.props.currentSlide === index + 1 || this.props.currentSlide === 0 && index === this.props.children.length - 1)) {
	        offset = this.props.slideOffset;
	      } else if (this.props.animation === 'zoom' && (this.props.currentSlide === index - 1 || this.props.currentSlide === this.props.children.length - 1 && index === 0)) {
	        offset = -this.props.slideOffset;
	      }
	
	      if (this.props.wrapAround && index !== startSlide) {
	        var direction = this.getSlideDirection(startSlide, this.props.currentSlide, this.props.isWrappingAround);
	        var slidesBefore = Math.floor((this.props.slideCount - 1) / 2);
	        var slidesAfter = this.props.slideCount - slidesBefore - 1;
	
	        if (direction < 0) {
	          var temp = slidesBefore;
	          slidesBefore = slidesAfter;
	          slidesAfter = temp;
	        }
	
	        var distanceFromStart = Math.abs(startSlide - index);
	
	        if (index < startSlide) {
	          if (distanceFromStart > slidesBefore) {
	            targetPosition = (this.props.slideWidth + this.props.cellSpacing) * (this.props.slideCount + index);
	          }
	        } else if (distanceFromStart > slidesAfter) {
	          targetPosition = (this.props.slideWidth + this.props.cellSpacing) * (this.props.slideCount - index) * -1;
	        }
	      }
	
	      return targetPosition + offset;
	    }
	    /* eslint-enable complexity */
	
	  }, {
	    key: "formatChildren",
	    value: function formatChildren(children) {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          top = _this$props.top,
	          left = _this$props.left,
	          currentSlide = _this$props.currentSlide,
	          slidesToShow = _this$props.slidesToShow;
	      var positionValue = this.props.vertical ? top : left;
	      return _react["default"].Children.map(children, function (child, index) {
	        var visible = index >= currentSlide && index < currentSlide + slidesToShow;
	        return _react["default"].createElement("li", {
	          className: "slider-slide".concat(visible ? ' slide-visible' : ''),
	          style: _this2.getSlideStyles(index, positionValue),
	          key: index
	        }, child);
	      });
	    }
	  }, {
	    key: "getSlideStyles",
	    value: function getSlideStyles(index, positionValue) {
	      var targetPosition = this.getSlideTargetPosition(index, positionValue);
	      var transformScale = this.props.animation === 'zoom' && this.props.currentSlide !== index ? Math.max(Math.min(this.props.zoomScale, MAX_ZOOM_SCALE), MIN_ZOOM_SCALE) : 1.0;
	      return {
	        boxSizing: 'border-box',
	        display: this.props.vertical ? 'block' : 'inline-block',
	        height: 'auto',
	        left: this.props.vertical ? 0 : targetPosition,
	        listStyleType: 'none',
	        marginBottom: this.props.vertical ? this.props.cellSpacing / 2 : 'auto',
	        marginLeft: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
	        marginRight: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
	        marginTop: this.props.vertical ? this.props.cellSpacing / 2 : 'auto',
	        MozBoxSizing: 'border-box',
	        position: 'absolute',
	        top: this.props.vertical ? targetPosition : 0,
	        transform: "scale(".concat(transformScale, ")"),
	        transition: 'transform .4s linear',
	        verticalAlign: 'top',
	        width: this.props.vertical ? '100%' : this.props.slideWidth
	      };
	    }
	  }, {
	    key: "getListStyles",
	    value: function getListStyles(styles) {
	      var deltaX = styles.deltaX,
	          deltaY = styles.deltaY;
	
	      var listWidth = this.props.slideWidth * _react["default"].Children.count(this.props.children);
	
	      var spacingOffset = this.props.cellSpacing * _react["default"].Children.count(this.props.children);
	
	      var transform = "translate3d(".concat(deltaX, "px, ").concat(deltaY, "px, 0)");
	      return {
	        transform: transform,
	        WebkitTransform: transform,
	        msTransform: "translate(".concat(deltaX, "px, ").concat(deltaY, "px)"),
	        position: 'relative',
	        display: 'block',
	        margin: this.props.vertical ? "".concat(this.props.cellSpacing / 2 * -1, "px 0px") : "0px ".concat(this.props.cellSpacing / 2 * -1, "px"),
	        padding: 0,
	        height: this.props.vertical ? listWidth + spacingOffset : this.props.slideHeight,
	        width: this.props.vertical ? 'auto' : listWidth + spacingOffset,
	        cursor: this.props.dragging === true ? 'pointer' : 'inherit',
	        boxSizing: 'border-box',
	        MozBoxSizing: 'border-box',
	        touchAction: "pinch-zoom ".concat(this.props.vertical ? 'pan-x' : 'pan-y')
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var children = this.formatChildren(this.props.children);
	      var deltaX = this.props.deltaX;
	      var deltaY = this.props.deltaY;
	      return _react["default"].createElement("ul", {
	        className: "slider-list",
	        style: this.getListStyles({
	          deltaX: deltaX,
	          deltaY: deltaY
	        })
	      }, children);
	    }
	  }]);
	
	  return ScrollTransition;
	}(_react["default"].Component);
	
	exports["default"] = ScrollTransition;
	ScrollTransition.propTypes = {
	  animation: _propTypes["default"].oneOf(['zoom']),
	  cellSpacing: _propTypes["default"].number,
	  currentSlide: _propTypes["default"].number,
	  deltaX: _propTypes["default"].number,
	  deltaY: _propTypes["default"].number,
	  dragging: _propTypes["default"].bool,
	  isWrappingAround: _propTypes["default"].bool,
	  left: _propTypes["default"].number,
	  slideCount: _propTypes["default"].number,
	  slideHeight: _propTypes["default"].number,
	  slideOffset: _propTypes["default"].number,
	  slideWidth: _propTypes["default"].number,
	  top: _propTypes["default"].number,
	  vertical: _propTypes["default"].bool,
	  wrapAround: _propTypes["default"].bool,
	  zoomScale: _propTypes["default"].number
	};
	ScrollTransition.defaultProps = {
	  cellSpacing: 0,
	  currentSlide: 0,
	  deltaX: 0,
	  deltaY: 0,
	  dragging: false,
	  isWrappingAround: false,
	  left: 0,
	  slideCount: 0,
	  slideHeight: 0,
	  slideWidth: 0,
	  top: 0,
	  vertical: false,
	  wrapAround: false,
	  zoomScale: 0.85
	};

/***/ }),

/***/ 1029:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSlideHeight = exports.getValidChildren = exports.addAccessibility = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var addAccessibility = function addAccessibility(children, slidesToShow) {
	  if (slidesToShow > 1) {
	    return _react["default"].Children.map(children, function (child) {
	      return _react["default"].cloneElement(child, child.props);
	    });
	  } else {
	    // when slidesToshow is 1
	    return _react["default"].Children.map(children, function (child) {
	      return _react["default"].cloneElement(child, child.props);
	    });
	  }
	};
	
	exports.addAccessibility = addAccessibility;
	
	var getValidChildren = function getValidChildren(children) {
	  // .toArray automatically removes invalid React children
	  return _react["default"].Children.toArray(children);
	};
	
	exports.getValidChildren = getValidChildren;
	
	var findMaxHeightSlide = function findMaxHeightSlide(slides) {
	  var maxHeight = 0;
	
	  for (var i = 0; i < slides.length; i++) {
	    if (slides[i].offsetHeight > maxHeight) {
	      maxHeight = slides[i].offsetHeight;
	    }
	  }
	
	  return maxHeight;
	};
	
	var getSlideHeight = function getSlideHeight(props, state) {
	  var childNodes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	  var heightMode = props.heightMode,
	      vertical = props.vertical,
	      initialSlideHeight = props.initialSlideHeight;
	  var slidesToShow = state.slidesToShow,
	      currentSlide = state.currentSlide;
	  var firstSlide = childNodes[0];
	
	  if (firstSlide && heightMode === 'first') {
	    return vertical ? firstSlide.offsetHeight * slidesToShow : firstSlide.offsetHeight;
	  }
	
	  if (heightMode === 'max') {
	    return findMaxHeightSlide(childNodes);
	  }
	
	  if (heightMode === 'current') {
	    return childNodes[currentSlide].offsetHeight;
	  }
	
	  return initialSlideHeight || 100;
	};
	
	exports.getSlideHeight = getSlideHeight;

/***/ }),

/***/ 1030:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTransitionProps = exports.getFrameStyles = exports.getSliderStyles = exports.getDecoratorStyles = exports.getImgTagStyles = void 0;
	
	var getImgTagStyles = function getImgTagStyles() {
	  return ".slider-slide > img { width: 100%; display: block; }\n          .slider-slide > img:focus { margin: auto; }";
	};
	
	exports.getImgTagStyles = getImgTagStyles;
	
	var getDecoratorStyles = function getDecoratorStyles(position) {
	  switch (position) {
	    case 'TopLeft':
	      {
	        return {
	          position: 'absolute',
	          top: 0,
	          left: 0
	        };
	      }
	
	    case 'TopCenter':
	      {
	        return {
	          position: 'absolute',
	          top: 0,
	          left: '50%',
	          transform: 'translateX(-50%)',
	          WebkitTransform: 'translateX(-50%)',
	          msTransform: 'translateX(-50%)'
	        };
	      }
	
	    case 'TopRight':
	      {
	        return {
	          position: 'absolute',
	          top: 0,
	          right: 0
	        };
	      }
	
	    case 'CenterLeft':
	      {
	        return {
	          position: 'absolute',
	          top: '50%',
	          left: 0,
	          transform: 'translateY(-50%)',
	          WebkitTransform: 'translateY(-50%)',
	          msTransform: 'translateY(-50%)'
	        };
	      }
	
	    case 'CenterCenter':
	      {
	        return {
	          position: 'absolute',
	          top: '50%',
	          left: '50%',
	          transform: 'translate(-50%,-50%)',
	          WebkitTransform: 'translate(-50%, -50%)',
	          msTransform: 'translate(-50%, -50%)'
	        };
	      }
	
	    case 'CenterRight':
	      {
	        return {
	          position: 'absolute',
	          top: '50%',
	          right: 0,
	          transform: 'translateY(-50%)',
	          WebkitTransform: 'translateY(-50%)',
	          msTransform: 'translateY(-50%)'
	        };
	      }
	
	    case 'BottomLeft':
	      {
	        return {
	          position: 'absolute',
	          bottom: 0,
	          left: 0
	        };
	      }
	
	    case 'BottomCenter':
	      {
	        return {
	          position: 'absolute',
	          bottom: 0,
	          left: '50%',
	          transform: 'translateX(-50%)',
	          WebkitTransform: 'translateX(-50%)',
	          msTransform: 'translateX(-50%)'
	        };
	      }
	
	    case 'BottomRight':
	      {
	        return {
	          position: 'absolute',
	          bottom: 0,
	          right: 0
	        };
	      }
	
	    default:
	      {
	        return {
	          position: 'absolute',
	          top: 0,
	          left: 0
	        };
	      }
	  }
	};
	
	exports.getDecoratorStyles = getDecoratorStyles;
	
	var getSliderStyles = function getSliderStyles(propWidth, propHeight) {
	  return {
	    boxSizing: 'border-box',
	    display: 'block',
	    height: propHeight,
	    MozBoxSizing: 'border-box',
	    position: 'relative',
	    width: propWidth
	  };
	};
	
	exports.getSliderStyles = getSliderStyles;
	
	var getFrameStyles = function getFrameStyles(propFrameOverFlow, propVertical, propFramePadding, stateFrameWidth) {
	  return {
	    boxSizing: 'border-box',
	    display: 'block',
	    height: propVertical ? stateFrameWidth || 'initial' : '100%',
	    margin: propFramePadding,
	    MozBoxSizing: 'border-box',
	    msTransform: 'translate(0, 0)',
	    overflow: propFrameOverFlow,
	    padding: 0,
	    position: 'relative',
	    touchAction: "pinch-zoom ".concat(propVertical ? 'pan-x' : 'pan-y'),
	    transform: 'translate3d(0, 0, 0)',
	    WebkitTransform: 'translate3d(0, 0, 0)'
	  };
	};
	
	exports.getFrameStyles = getFrameStyles;
	
	var getTransitionProps = function getTransitionProps(props, state) {
	  return {
	    animation: props.animation,
	    cellSpacing: props.cellSpacing,
	    currentSlide: state.currentSlide,
	    dragging: props.dragging,
	    isWrappingAround: state.isWrappingAround,
	    left: state.left,
	    slideCount: state.slideCount,
	    slideHeight: state.slideHeight,
	    slideOffset: props.slideOffset,
	    slidesToShow: state.slidesToShow,
	    slideWidth: state.slideWidth,
	    top: state.top,
	    vertical: props.vertical,
	    wrapAround: props.wrapAround,
	    zoomScale: props.zoomScale,
	    opacityScale: props.opacityScale,
	    slideListMargin: props.slideListMargin
	  };
	};
	
	exports.getTransitionProps = getTransitionProps;

/***/ }),

/***/ 1031:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calcSomeInitialState = exports.shouldUpdate = exports.swipeDirection = exports.getPropsByTransitionMode = exports.addAccessibility = exports.removeEvent = exports.addEvent = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var addEvent = function addEvent(elem, type, eventHandle) {
	  if (elem === null || typeof elem === 'undefined') {
	    return;
	  }
	
	  if (elem.addEventListener) {
	    elem.addEventListener(type, eventHandle, false);
	  } else if (elem.attachEvent) {
	    elem.attachEvent("on".concat(type), eventHandle);
	  } else {
	    elem["on".concat(type)] = eventHandle;
	  }
	};
	
	exports.addEvent = addEvent;
	
	var removeEvent = function removeEvent(elem, type, eventHandle) {
	  if (elem === null || typeof elem === 'undefined') {
	    return;
	  }
	
	  if (elem.removeEventListener) {
	    elem.removeEventListener(type, eventHandle, false);
	  } else if (elem.detachEvent) {
	    elem.detachEvent("on".concat(type), eventHandle);
	  } else {
	    elem["on".concat(type)] = null;
	  }
	};
	
	exports.removeEvent = removeEvent;
	
	var addAccessibility = function addAccessibility(children, slidesToShow, currentSlide) {
	  var needsTabIndex;
	
	  if (slidesToShow > 1) {
	    return _react["default"].Children.map(children, function (child, index) {
	      var firstVisibleSlide = index >= currentSlide;
	      var lastVisibleSlide = index < slidesToShow + currentSlide;
	      needsTabIndex = firstVisibleSlide && lastVisibleSlide;
	      var ariaProps = needsTabIndex ? {
	        'aria-hidden': 'false',
	        tabIndex: 0
	      } : {
	        'aria-hidden': 'true'
	      };
	      return _react["default"].cloneElement(child, _objectSpread({}, child.props, {}, ariaProps));
	    });
	  } else {
	    return _react["default"].Children.map(children, function (child, index) {
	      needsTabIndex = index !== currentSlide;
	      var ariaProps = needsTabIndex ? {
	        'aria-hidden': 'true'
	      } : {
	        'aria-hidden': 'false',
	        tabIndex: 0
	      };
	      return _react["default"].cloneElement(child, _objectSpread({}, child.props, {}, ariaProps));
	    });
	  }
	};
	
	exports.addAccessibility = addAccessibility;
	
	var getPropsByTransitionMode = function getPropsByTransitionMode(props, keys) {
	  var slidesToShow = props.slidesToShow,
	      transitionMode = props.transitionMode;
	  var updatedDefaults = {};
	
	  if (transitionMode === 'fade') {
	    keys.forEach(function (key) {
	      switch (key) {
	        case 'slidesToShow':
	          updatedDefaults[key] = Math.max(parseInt(slidesToShow), 1);
	          break;
	
	        case 'slidesToScroll':
	          updatedDefaults[key] = Math.max(parseInt(slidesToShow), 1);
	          break;
	
	        case 'cellAlign':
	          updatedDefaults[key] = 'left';
	          break;
	
	        default:
	          updatedDefaults[key] = props[key];
	          break;
	      }
	    });
	  } else {
	    keys.forEach(function (key) {
	      updatedDefaults[key] = props[key];
	    });
	  }
	
	  return updatedDefaults;
	};
	
	exports.getPropsByTransitionMode = getPropsByTransitionMode;
	
	var swipeDirection = function swipeDirection(x1, x2, y1, y2, vertical) {
	  var xDist = x1 - x2;
	  var yDist = y1 - y2;
	  var r = Math.atan2(yDist, xDist);
	  var swipeAngle = Math.round(r * 180 / Math.PI);
	
	  if (swipeAngle < 0) {
	    swipeAngle = 360 - Math.abs(swipeAngle);
	  }
	
	  if (swipeAngle <= 45 && swipeAngle >= 0) {
	    return 1;
	  }
	
	  if (swipeAngle <= 360 && swipeAngle >= 315) {
	    return 1;
	  }
	
	  if (swipeAngle >= 135 && swipeAngle <= 225) {
	    return -1;
	  }
	
	  if (vertical === true) {
	    if (swipeAngle >= 35 && swipeAngle <= 135) {
	      return 1;
	    } else {
	      return -1;
	    }
	  }
	
	  return 0;
	};
	
	exports.swipeDirection = swipeDirection;
	
	var shouldUpdate = function shouldUpdate(curr, next, keys) {
	  var update = false;
	
	  for (var i = 0; i < keys.length; i++) {
	    if (curr[keys[i]] !== next[keys[i]]) {
	      update = true;
	      break;
	    }
	  }
	
	  return update;
	};
	
	exports.shouldUpdate = shouldUpdate;
	
	var calcSomeInitialState = function calcSomeInitialState(props) {
	  var _getPropsByTransition = getPropsByTransitionMode(props, ['slidesToScroll', 'slidesToShow', 'cellAlign']),
	      slidesToScroll = _getPropsByTransition.slidesToScroll,
	      slidesToShow = _getPropsByTransition.slidesToShow,
	      cellAlign = _getPropsByTransition.cellAlign;
	
	  var slideWidth = props.vertical ? props.initialSlideHeight || 0 : props.initialSlideWidth || 0;
	  var slideHeight = props.vertical ? (props.initialSlideHeight || 0) * props.slidesToShow : props.initialSlideHeight || 0;
	  var frameHeight = slideHeight + props.cellSpacing * (slidesToShow - 1);
	  var frameWidth = props.vertical ? frameHeight : '100%';
	  return {
	    slideWidth: slideWidth,
	    slideHeight: slideHeight,
	    frameWidth: frameWidth,
	    slidesToScroll: slidesToScroll,
	    slidesToShow: slidesToShow,
	    cellAlign: cellAlign
	  };
	};
	
	exports.calcSomeInitialState = calcSomeInitialState;

/***/ }),

/***/ 1442:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ }),

/***/ 1443:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _NodeGroup = _interopRequireDefault(__webpack_require__(1444));
	
	var _utils = __webpack_require__(827);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var keyAccessor = function keyAccessor() {
	  return '$$key$$';
	};
	
	var Animate = function (_Component) {
	  _inherits(Animate, _Component);
	
	  function Animate() {
	    _classCallCheck(this, Animate);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Animate).apply(this, arguments));
	  }
	
	  _createClass(Animate, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          show = _this$props.show,
	          start = _this$props.start,
	          enter = _this$props.enter,
	          update = _this$props.update,
	          leave = _this$props.leave,
	          interpolation = _this$props.interpolation,
	          children = _this$props.children;
	      var data = typeof start === 'function' ? start() : start;
	      return _react.default.createElement(_NodeGroup.default, {
	        data: show ? [data] : [],
	        start: function start() {
	          return data;
	        },
	        keyAccessor: keyAccessor,
	        interpolation: interpolation,
	        enter: typeof enter === 'function' ? enter : function () {
	          return enter;
	        },
	        update: typeof update === 'function' ? update : function () {
	          return update;
	        },
	        leave: typeof leave === 'function' ? leave : function () {
	          return leave;
	        }
	      }, function (nodes) {
	        if (!nodes[0]) {
	          return null;
	        }
	
	        var renderedChildren = children(nodes[0].state);
	        return renderedChildren && _react.default.Children.only(renderedChildren);
	      });
	    }
	  }]);
	
	  return Animate;
	}(_react.Component);
	
	Animate.propTypes =  false ? {
	  show: _propTypes.default.bool,
	  interpolation: _propTypes.default.func,
	  start: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
	  enter: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array, _propTypes.default.object]),
	  update: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array, _propTypes.default.object]),
	  leave: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array, _propTypes.default.object]),
	  children: _propTypes.default.func.isRequired
	} : {};
	Animate.defaultProps = {
	  show: true,
	  interpolation: _utils.numeric
	};
	var _default = Animate;
	exports.default = _default;

/***/ }),

/***/ 1444:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(1442);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _kapellmeister = __webpack_require__(1012);
	
	var _mergeKeys = _interopRequireDefault(__webpack_require__(1445));
	
	var _types = __webpack_require__(1446);
	
	var _utils = __webpack_require__(827);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NodeGroup = function (_Component) {
	  _inherits(NodeGroup, _Component);
	
	  function NodeGroup(props) {
	    var _this;
	
	    _classCallCheck(this, NodeGroup);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(NodeGroup).call(this, props));
	
	    _defineProperty(_assertThisInitialized(_this), "animate", function () {
	      var _this$state = _this.state,
	          nodeKeys = _this$state.nodeKeys,
	          nodeHash = _this$state.nodeHash;
	
	      if (_this.unmounting) {
	        return;
	      }
	
	      var pending = false;
	      var nextNodeKeys = [];
	      var length = nodeKeys.length;
	
	      for (var i = 0; i < length; i++) {
	        var k = nodeKeys[i];
	        var n = nodeHash[k];
	        var isTransitioning = n.isTransitioning();
	
	        if (isTransitioning) {
	          pending = true;
	        }
	
	        if (n.type === _types.LEAVE && !isTransitioning) {
	          delete nodeHash[k];
	        } else {
	          nextNodeKeys.push(k);
	        }
	      }
	
	      if (!pending) {
	        _this.interval.stop();
	      }
	
	      _this.setState(function () {
	        return {
	          nodeKeys: nextNodeKeys,
	          nodes: nextNodeKeys.map(function (key) {
	            return nodeHash[key];
	          })
	        };
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "interval", null);
	
	    _defineProperty(_assertThisInitialized(_this), "unmounting", false);
	
	    var interpolation = props.interpolation;
	
	    var Node = function (_BaseNode) {
	      _inherits(Node, _BaseNode);
	
	      function Node(key, data) {
	        var _this2;
	
	        _classCallCheck(this, Node);
	
	        _this2 = _possibleConstructorReturn(this, _getPrototypeOf(Node).call(this));
	
	        _defineProperty(_assertThisInitialized(_this2), "getInterpolator", interpolation);
	
	        _this2.key = key;
	        _this2.data = data;
	        _this2.type = _types.ENTER;
	        return _this2;
	      }
	
	      return Node;
	    }(_kapellmeister.BaseNode);
	
	    _this.state = {
	      Node: Node,
	      nodeKeys: [],
	      nodeHash: {},
	      nodes: [],
	      data: null
	    };
	    return _this;
	  }
	
	  _createClass(NodeGroup, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.startInterval();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.data !== this.props.data && !this.unmounting) {
	        this.startInterval();
	      }
	    }
	  }, {
	    key: "startInterval",
	    value: function startInterval() {
	      if (!this.interval) {
	        this.interval = (0, _kapellmeister.interval)(this.animate);
	      } else {
	        this.interval.restart(this.animate);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var _this$state2 = this.state,
	          nodeKeys = _this$state2.nodeKeys,
	          nodeHash = _this$state2.nodeHash;
	      this.unmounting = true;
	
	      if (this.interval) {
	        this.interval.stop();
	      }
	
	      nodeKeys.forEach(function (key) {
	        nodeHash[key].stopTransitions();
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var renderedChildren = this.props.children(this.state.nodes);
	      return renderedChildren && _react.default.Children.only(renderedChildren);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      if (nextProps.data !== prevState.data) {
	        var data = nextProps.data,
	            keyAccessor = nextProps.keyAccessor,
	            start = nextProps.start,
	            enter = nextProps.enter,
	            update = nextProps.update,
	            leave = nextProps.leave;
	        var Node = prevState.Node,
	            nodeKeys = prevState.nodeKeys,
	            nodeHash = prevState.nodeHash;
	        var keyIndex = {};
	
	        for (var i = 0; i < nodeKeys.length; i++) {
	          keyIndex[nodeKeys[i]] = i;
	        }
	
	        var nextKeyIndex = {};
	        var nextNodeKeys = [];
	
	        for (var _i = 0; _i < data.length; _i++) {
	          var d = data[_i];
	          var k = keyAccessor(d, _i);
	          nextKeyIndex[k] = _i;
	          nextNodeKeys.push(k);
	
	          if (keyIndex[k] === undefined) {
	            var node = new Node();
	            node.key = k;
	            node.data = d;
	            node.type = _types.ENTER;
	            nodeHash[k] = node;
	          }
	        }
	
	        for (var _i2 = 0; _i2 < nodeKeys.length; _i2++) {
	          var _k = nodeKeys[_i2];
	          var n = nodeHash[_k];
	
	          if (nextKeyIndex[_k] !== undefined) {
	            n.data = data[nextKeyIndex[_k]];
	            n.type = _types.UPDATE;
	          } else {
	            n.type = _types.LEAVE;
	          }
	        }
	
	        var mergedNodeKeys = (0, _mergeKeys.default)(nodeKeys, keyIndex, nextNodeKeys, nextKeyIndex);
	
	        for (var _i3 = 0; _i3 < mergedNodeKeys.length; _i3++) {
	          var _k2 = mergedNodeKeys[_i3];
	          var _n = nodeHash[_k2];
	          var _d = _n.data;
	
	          if (_n.type === _types.ENTER) {
	            _n.setState(start(_d, nextKeyIndex[_k2]));
	
	            _n.transition(enter(_d, nextKeyIndex[_k2]));
	          } else if (_n.type === _types.LEAVE) {
	            _n.transition(leave(_d, keyIndex[_k2]));
	          } else {
	            _n.transition(update(_d, nextKeyIndex[_k2]));
	          }
	        }
	
	        return {
	          data: data,
	          nodes: mergedNodeKeys.map(function (key) {
	            return nodeHash[key];
	          }),
	          nodeHash: nodeHash,
	          nodeKeys: mergedNodeKeys
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return NodeGroup;
	}(_react.Component);
	
	NodeGroup.propTypes =  false ? {
	  data: _propTypes.default.array.isRequired,
	  keyAccessor: _propTypes.default.func.isRequired,
	  interpolation: _propTypes.default.func,
	  start: _propTypes.default.func.isRequired,
	  enter: _propTypes.default.func,
	  update: _propTypes.default.func,
	  leave: _propTypes.default.func,
	  children: _propTypes.default.func.isRequired
	} : {};
	NodeGroup.defaultProps = {
	  enter: function enter() {},
	  update: function update() {},
	  leave: function leave() {},
	  interpolation: _utils.numeric
	};
	(0, _reactLifecyclesCompat.polyfill)(NodeGroup);
	var _default = NodeGroup;
	exports.default = _default;

/***/ }),

/***/ 1445:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function mergeKeys(currNodeKeys, currKeyIndex, nextNodeKeys, nextKeyIndex) {
	  var allKeys = [];
	
	  for (var i = 0; i < nextNodeKeys.length; i++) {
	    allKeys[i] = nextNodeKeys[i];
	  }
	
	  for (var _i = 0; _i < currNodeKeys.length; _i++) {
	    if (nextKeyIndex[currNodeKeys[_i]] === undefined) {
	      allKeys.push(currNodeKeys[_i]);
	    }
	  }
	
	  return allKeys.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a];
	    var nextOrderB = nextKeyIndex[b];
	    var currOrderA = currKeyIndex[a];
	    var currOrderB = currKeyIndex[b];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      return nextKeyIndex[a] - nextKeyIndex[b];
	    } else if (currOrderA != null && currOrderB != null) {
	      return currKeyIndex[a] - currKeyIndex[b];
	    } else if (nextOrderA != null) {
	      for (var _i2 = 0; _i2 < nextNodeKeys.length; _i2++) {
	        var pivot = nextNodeKeys[_i2];
	
	        if (!currKeyIndex[pivot]) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && currOrderB > currKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && currOrderB < currKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	
	      return 1;
	    }
	
	    for (var _i3 = 0; _i3 < nextNodeKeys.length; _i3++) {
	      var _pivot = nextNodeKeys[_i3];
	
	      if (!currKeyIndex[_pivot]) {
	        continue;
	      }
	
	      if (nextOrderB < nextKeyIndex[_pivot] && currOrderA > currKeyIndex[_pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[_pivot] && currOrderA < currKeyIndex[_pivot]) {
	        return -1;
	      }
	    }
	
	    return -1;
	  });
	}
	
	var _default = mergeKeys;
	exports.default = _default;

/***/ }),

/***/ 1446:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LEAVE = exports.UPDATE = exports.ENTER = void 0;
	var ENTER = 'ENTER';
	exports.ENTER = ENTER;
	var UPDATE = 'UPDATE';
	exports.UPDATE = UPDATE;
	var LEAVE = 'LEAVE';
	exports.LEAVE = LEAVE;

/***/ }),

/***/ 827:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.numeric = numeric;
	
	function numeric(beg, end) {
	  var a = +beg;
	  var b = +end - a;
	  return function (t) {
	    return a + b * t;
	  };
	}

/***/ }),

/***/ 1501:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cal.d466b548.jpg";

/***/ }),

/***/ 1502:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/car.2d94541b.jpg";

/***/ }),

/***/ 1503:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/feedback.4397a070.jpg";

/***/ }),

/***/ 1504:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/movie.35bc0af1.jpg";

/***/ }),

/***/ 1505:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/taco.96f88731.png";

/***/ }),

/***/ 1506:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/todo.6b71516d.jpg";

/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HeadlineWithFocus = __webpack_require__(29);
	
	var _HeadlineWithFocus2 = _interopRequireDefault(_HeadlineWithFocus);
	
	var _reactHelmet = __webpack_require__(56);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _car = __webpack_require__(1502);
	
	var _car2 = _interopRequireDefault(_car);
	
	var _cal = __webpack_require__(1501);
	
	var _cal2 = _interopRequireDefault(_cal);
	
	var _feedback = __webpack_require__(1503);
	
	var _feedback2 = _interopRequireDefault(_feedback);
	
	var _movie = __webpack_require__(1504);
	
	var _movie2 = _interopRequireDefault(_movie);
	
	var _todo = __webpack_require__(1506);
	
	var _todo2 = _interopRequireDefault(_todo);
	
	var _taco = __webpack_require__(1505);
	
	var _taco2 = _interopRequireDefault(_taco);
	
	var _nukaCarousel = __webpack_require__(1022);
	
	var _nukaCarousel2 = _interopRequireDefault(_nukaCarousel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    { className: "c-content-box" },
	    _react2.default.createElement(_reactHelmet2.default, { title: "Let's play" }),
	    _react2.default.createElement(
	      _HeadlineWithFocus2.default,
	      null,
	      "My Work"
	    ),
	    _react2.default.createElement("br", null),
	    _react2.default.createElement(
	      _nukaCarousel2.default,
	      null,
	      _react2.default.createElement("img", { src: _taco2.default }),
	      _react2.default.createElement("img", { src: _car2.default }),
	      _react2.default.createElement("img", { src: _feedback2.default }),
	      _react2.default.createElement("img", { src: _movie2.default }),
	      _react2.default.createElement("img", { src: _cal2.default }),
	      _react2.default.createElement("img", { src: _todo2.default })
	    ),
	    _react2.default.createElement(
	      "ol",
	      null,
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "a",
	          { href: "https://taco-fresh.herokuapp.com/" },
	          "Taco Fresh"
	        )
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "a",
	          { href: "https://car-problems.herokuapp.com/#/home" },
	          "Car probelms"
	        )
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "a",
	          { href: "https://feedback-form-01.herokuapp.com/" },
	          "Feedback Form"
	        )
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "a",
	          { href: " https://movie-list-01.herokuapp.com/" },
	          "Movie List"
	        )
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "a",
	          { href: "https://simple-calculator-001.herokuapp.com/" },
	          "Calculator server side"
	        )
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "a",
	          { href: "https://weekend-to-do-list-01.herokuapp.com/" },
	          "To do list"
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-jsx-63a035c5a02c50bcc4e1.js